var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.66669 491.67999",
    height: 491.67999,
    width: 666.66669,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath100",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "m 2280.28,3020.6 h -69.1 v 224.58 h 69.1 -69.1 v -31.67 h 69.1 V 3020.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath540",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path538",
    d: "m 3297.79,1511.48 c -6.32,2 -10.01,3.23 -10.16,3.28 0.15,-0.05 3.83,-1.27 10.16,-3.28 v 0 m -10.16,3.28 v 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,491.68)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4167.79,252.199 h 331.22 v -2.5 h -331.22 v 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3225.27,225.07 h 86.93 v -2.5 h -86.93 v 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3965.86,342.57 h 191.922 v 2.5 H 3965.86 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 524.594,328.262 h 431.929 v -2.5 H 524.594 v 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1045.56,328.262 h 63.33 v -2.5 h -63.33 v 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1314.71,283.539 h 936.758 v 2.5 H 1314.71 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 439.152,3685.12 c -30.097,0 -54.582,-24.48 -54.582,-54.58 V 916.23 c 0,-30.101 24.485,-54.582 54.582,-54.582 H 2370.14 c 30.09,0 54.57,24.481 54.57,54.582 v 2714.31 c 0,30.1 -24.48,54.58 -54.57,54.58 H 439.152 M 2370.14,859.148 H 439.152 c -31.472,0 -57.082,25.602 -57.082,57.082 v 2714.31 c 0,31.48 25.61,57.08 57.082,57.08 H 2370.14 c 31.46,0 57.07,-25.6 57.07,-57.08 V 916.23 c 0,-31.48 -25.61,-57.082 -57.07,-57.082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2602.12,3685.12 c -30.09,0 -54.57,-24.48 -54.57,-54.58 V 916.23 c 0,-30.101 24.48,-54.582 54.57,-54.582 h 1930.99 c 30.09,0 54.58,24.481 54.58,54.582 v 2714.31 c 0,30.1 -24.49,54.58 -54.58,54.58 H 2602.12 M 4533.11,859.148 H 2602.12 c -31.46,0 -57.07,25.602 -57.07,57.082 v 2714.31 c 0,31.48 25.61,57.08 57.07,57.08 h 1930.99 c 31.47,0 57.08,-25.6 57.08,-57.08 V 916.23 c 0,-31.48 -25.61,-57.082 -57.08,-57.082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0.00390625,410.66 H 5000.0039 v 2.5 H 0.00390625 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 858.566,2429.5 v 194.75 h -15 V 2429.5 c -9.652,-3.17 -16.664,-12.15 -16.664,-22.86 v -61.67 c 0,-13.35 10.817,-24.17 24.164,-24.17 13.344,0 24.164,10.82 24.164,24.17 v 61.67 c 0,10.71 -7.015,19.69 -16.664,22.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 901.844,431.672 h 29.875 v 2192.58 h -29.875 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1111.78,422.648 H 721.785 c 0,20.153 16.332,36.493 36.481,36.493 H 1075.3 c 20.15,0 36.48,-16.34 36.48,-36.493"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 901.844,2469.18 29.883,9.84 v 145.23 h -29.883 v -155.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1095.78,3079.14 H 737.785 l -110,-475 h 577.995 l -110,475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2666.58,2945.28 v 85.28 c -10.5,0 -10.52,16.33 0,16.33 32.5,0 65.03,0.23 97.55,0.42 v -118.36 c -32.51,0 -65.03,0 -97.55,0 -10.5,0 -10.52,16.33 0,16.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#f8f8f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2742.36,2945.4 h -75.78 v 85.16 h 75.78 v -85.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#fcfdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2726.46,2937.12 h 262.71 c 18.06,0 32.7,22.74 32.7,50.8 0,28.06 -14.64,50.81 -32.7,50.81 h -262.71 v -101.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#e9e9e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2726.46,3046.89 c 86.01,0 172.16,1.56 258.15,0 58.91,-1.06 62.08,-113.98 4.3,-117.94 -40.28,-2.76 -81.71,0 -122.06,0 -46.8,0 -93.6,0 -140.39,0 -10.51,0 -10.53,16.33 0,16.33 81.52,0 163.04,0 244.56,0 18.86,0 32.36,0.21 39.65,22.47 6.31,19.26 4.33,58.56 -21.5,62.81 -2.78,0.46 -6.06,0 -8.85,0 -44.44,0 -88.89,0 -133.34,0 -40.17,0 -80.35,0 -120.52,0 -10.51,0 -10.53,16.33 0,16.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2665.7,3060.44 v 75.79 c -9.34,0 -9.35,14.52 0,14.52 28.89,0 57.79,0.19 86.7,0.37 v -105.19 c -28.9,0 -57.8,0 -86.7,0 -9.34,0 -9.35,14.51 0,14.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#f8f8f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2733.05,3060.55 h -67.35 v 75.68 h 67.35 v -75.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#fcfdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2718.92,3053.19 h 233.46 c 16.05,0 29.07,20.21 29.07,45.15 0,24.93 -13.02,45.15 -29.07,45.15 h -233.46 v -90.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#e9e9e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2718.92,3150.75 c 76.43,0 153,1.38 229.42,0 52.35,-0.95 55.16,-101.29 3.81,-104.82 -35.79,-2.46 -72.61,0 -108.47,0 -41.59,0 -83.18,0 -124.76,0 -9.34,0 -9.36,14.51 0,14.51 72.44,0 144.89,0 217.34,0 16.76,0 28.75,0.19 35.24,19.97 5.6,17.12 3.84,52.04 -19.12,55.82 -2.47,0.41 -5.38,0 -7.86,0 -39.5,0 -79,0 -118.49,0 -35.71,0 -71.41,0 -107.11,0 -9.34,0 -9.36,14.52 0,14.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2666.58,2829.38 v 85.28 c -10.5,0 -10.52,16.33 0,16.33 32.5,0 65.03,0.22 97.55,0.41 v -118.36 c -32.51,0 -65.03,0 -97.55,0 -10.5,0 -10.52,16.34 0,16.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#f8f8f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2742.36,2829.5 h -75.78 v 85.16 h 75.78 v -85.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#fcfdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2726.46,2821.21 h 262.71 c 18.06,0 32.7,22.75 32.7,50.81 0,28.05 -14.64,50.8 -32.7,50.8 h -262.71 v -101.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#e9e9e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2726.46,2930.99 c 86.01,0 172.16,1.55 258.15,0 58.91,-1.06 62.08,-113.98 4.3,-117.95 -40.28,-2.76 -81.71,0 -122.06,0 -46.8,0 -93.6,0 -140.39,0 -10.51,0 -10.53,16.34 0,16.34 81.52,0 163.04,0 244.56,0 18.86,0 32.36,0.21 39.65,22.46 6.31,19.26 4.33,58.56 -21.5,62.82 -2.78,0.45 -6.06,0 -8.85,0 -44.44,0 -88.89,0 -133.34,0 -40.17,0 -80.35,0 -120.52,0 -10.51,0 -10.53,16.33 0,16.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#f8f8f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3312.01,2826.26 H 3861 V 2755.8 H 1542.47 v 70.46 h 1769.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3729.8,2584.51 v 171.29 h 85.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#f8f8f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3772.62,2584.51 85.64,171.29 h -42.82 l -85.64,-171.29 h 42.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1670.93,2584.51 v 171.29 h -85.64 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#f8f8f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1628.11,2584.51 -85.64,171.29 h 42.82 l 85.64,-171.29 h -42.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#e9e9e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3174.03,2997.82 c 0,-102.91 83.41,-186.32 186.31,-186.32 102.9,0 186.32,83.41 186.32,186.32 v 6.49 c 0,102.89 -83.42,186.31 -186.32,186.31 -102.9,0 -186.31,-83.42 -186.31,-186.31 v -6.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3174.03,3024.6 c 0,-102.9 83.41,-186.31 186.31,-186.31 102.9,0 186.32,83.41 186.32,186.31 v 6.49 c 0,102.9 -83.42,186.32 -186.32,186.32 -102.9,0 -186.31,-83.42 -186.31,-186.32 v -6.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#fcfdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3214.78,3031.09 c 0,-80.39 65.17,-145.56 145.56,-145.56 80.39,0 145.57,65.17 145.57,145.56 0,80.39 -65.18,145.56 -145.57,145.56 -80.39,0 -145.56,-65.17 -145.56,-145.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#e9e9e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3360.34,3153.67 c -76.51,0 -139.1,-59.07 -144.98,-134.07 -0.29,3.81 -0.58,7.61 -0.58,11.49 0,80.39 65.17,145.56 145.56,145.56 80.39,0 145.57,-65.17 145.57,-145.56 0,-3.88 -0.29,-7.68 -0.59,-11.49 -5.87,75 -68.47,134.07 -144.98,134.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3268.41,3031.17 c 4.36,0 51.36,0 76.53,0 0,25.19 0,72.27 0,76.53 0,8.51 6.9,15.4 15.4,15.4 8.51,0 15.4,-6.89 15.4,-15.4 0,-5.76 0,-86.17 0,-91.93 0,-8.51 -6.89,-15.4 -15.4,-15.4 -5.64,0 -86.3,0 -91.93,0 -8.51,0 -15.4,6.9 -15.4,15.4 0,8.5 6.89,15.4 15.4,15.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#f8f8f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3268.41,3015.69 c -8.51,0 -15.4,6.9 -15.4,15.4 0,8.51 6.89,15.4 15.4,15.4 5.76,0 86.17,0 91.93,0 8.51,0 15.4,-6.89 15.4,-15.4 0,-8.5 -6.89,-15.4 -15.4,-15.4 -5.64,0 -86.3,0 -91.93,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3344.94,3123.02 c 0,8.51 6.9,15.41 15.4,15.41 8.51,0 15.4,-6.9 15.4,-15.41 0,-5.76 0,-86.17 0,-91.93 0,-8.5 -6.89,-15.4 -15.4,-15.4 -8.5,0 -15.4,6.9 -15.4,15.4 0,5.64 0,86.3 0,91.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2189.59,2823.84 h 112.289 v 466.445 H 2189.59 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#fcfdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2211.18,2923.43 c 0,-19.08 15.47,-34.55 34.55,-34.55 19.08,0 34.55,15.47 34.55,34.55 0,19.08 -15.47,34.55 -34.55,34.55 -19.08,0 -34.55,-15.47 -34.55,-34.55"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g94"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath100)",
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#ededec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2211.18,3020.6 h 69.1016 v 224.578 H 2211.18 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#f7f8f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2211.18,3213.51 h 69.1016 v 31.6719 H 2211.18 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#e9e9e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2105.32,2823.84 h 90.6914 v 376.742 H 2105.32 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#fcfdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2122.76,2904.27 c 0,-15.41 12.5,-27.9 27.91,-27.9 15.41,0 27.91,12.49 27.91,27.9 0,15.42 -12.5,27.91 -27.91,27.91 -15.41,0 -27.91,-12.49 -27.91,-27.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#efefef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2178.58,2982.76 h -55.82 v 181.39 h 55.82 -55.82 v -25.58 h 55.82 v -155.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#f7f8f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2122.76,3138.57 h 55.8203 v 25.5781 H 2122.76 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2374.41,2823.84 h 112.281 v 466.445 H 2374.41 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2396,2923.43 c 0,-19.08 15.47,-34.55 34.55,-34.55 19.08,0 34.55,15.47 34.55,34.55 0,19.08 -15.47,34.55 -34.55,34.55 -19.08,0 -34.55,-15.47 -34.55,-34.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    style: {
      fill: "#f7f8f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2465.1,3020.6 H 2396 v 224.58 h 69.1 -69.1 v -31.67 h 69.1 V 3020.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#fafbfb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2396,3213.51 h 69.1016 v 31.6719 H 2396 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2001.05,2823.84 h 112.289 v 466.445 H 2001.05 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#fcfdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2022.65,2923.43 c 0,-19.08 15.47,-34.55 34.55,-34.55 19.08,0 34.55,15.47 34.55,34.55 0,19.08 -15.47,34.55 -34.55,34.55 -19.08,0 -34.55,-15.47 -34.55,-34.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#ededec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2091.75,3020.6 h -69.1 v 224.58 h 69.1 -69.1 v -31.67 h 69.1 V 3020.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#f7f8f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2022.65,3213.51 h 69.1016 v 31.6719 H 2022.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#eeeeee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1840.83,2830.98 111.67,-11.73 48.76,463.89 -111.67,11.73 -48.76,-463.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1872.72,2927.77 c -2,-18.97 11.77,-35.98 30.75,-37.97 18.97,-2 35.98,11.77 37.97,30.75 1.99,18.98 -11.77,35.98 -30.75,37.97 -18.98,2 -35.98,-11.77 -37.97,-30.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#f5f5f5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1951.6,3017.19 -68.73,7.22 20.17,191.85 68.72,-7.22 3.31,31.5 -23.47,-223.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#f7f8f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1903.04,3216.26 v 0 l 3.31,31.5 -3.31,-31.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1971.76,3209.04 -68.72,7.22 3.31,31.5 68.72,-7.22 -3.31,-31.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#e9e9e8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2293.85,2823.84 h 90.6992 v 376.742 H 2293.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    style: {
      fill: "#fcfdfd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2311.3,2904.27 c 0,-15.41 12.49,-27.9 27.9,-27.9 15.42,0 27.91,12.49 27.91,27.9 0,15.42 -12.49,27.91 -27.91,27.91 -15.41,0 -27.9,-12.49 -27.9,-27.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    style: {
      fill: "#efefef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2367.11,2982.76 h -55.81 v 181.39 h 55.81 -55.81 v -25.58 h 55.81 v -155.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    style: {
      fill: "#f7f8f8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2311.3,3138.57 h 55.8086 v 25.5781 H 2311.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    style: {
      fill: "#f8f8f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4390.67,113.238 C 4390.67,50.6992 3522.6,0.0117188 2451.78,0.0117188 1380.96,0.0117188 512.887,50.6992 512.887,113.238 c 0,62.532 868.073,113.231 1938.893,113.231 1070.82,0 1938.89,-50.699 1938.89,-113.231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2494.27,1489.1 h -187.4 l 90,284.97 h 187.4 l -90,-284.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "#cecdcc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2558,1690.88 v 0 l 11.04,34.98 v 0 L 2558,1690.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#395eb4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2558,1690.88 h -187.4 l 11.05,34.98 h 187.39 l -11.05,-34.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2283.98,1463.89 h 358.629 v 43.3281 H 2283.98 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2642.61,1463.89 h -179.32 v 43.33 h -179.31 v -43.33 43.33 h 358.63 v -43.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "#dbe8f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2463.29,1463.89 h -179.31 v 43.33 h 179.31 v -43.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4032.13,1835.97 -65.31,746.4 -1022.14,-90.12 H 1914.7 l -1037.915,90.12 -20,-20 65.297,-746.4 1037.888,-90.11 H 2990 l 1022.13,90.11 20,20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    style: {
      fill: "#658acf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3010,1745.86 H 1979.97 l -1037.888,90.11 -65.297,746.4 1037.915,-90.12 h 1029.98 l 1022.14,90.12 65.31,-746.4 -210.42,-18.55 c -4.35,10.24 -8.89,19.95 -13.65,29.03 l 191.67,16.9 -60.05,686.39 -57.74,-5.08 -904.86,-79.78 60.05,-686.4 277.4,24.46 c -6.32,-11.31 -11.81,-21.49 -16.03,-29.42 -5.62,3.44 -8.93,5.17 -8.93,5.17 l -4.42,-8.57 -275.15,-24.26 m -340.89,30 h 308.27 l -60.05,686.39 H 1947.3 l 60.05,-686.39 h 394.04 267.72 m -1759.473,773.88 60.051,-686.39 977.452,-84.87 -60.05,686.4 -62.51,5.43 -154.51,13.41 -760.433,66.02 M 2978.25,2108.51 c -4.14,0 -7.2,-3.36 -6.84,-7.5 l 27.51,-314.46 c 0.36,-4.14 4.02,-7.5 8.16,-7.5 4.14,0 7.2,3.36 6.84,7.5 l -27.51,314.46 c -0.36,4.14 -4.02,7.5 -8.16,7.5 m -1021.38,-98.33 c -4.14,0 -7.2,-3.36 -6.84,-7.5 l 18.91,-216.13 c 0.36,-4.14 4.01,-7.5 8.15,-7.5 4.14,0 7.21,3.36 6.85,7.5 l -18.91,216.13 c -0.36,4.14 -4.02,7.5 -8.16,7.5 m -30.33,346.67 c -4.14,0 -7.21,-3.36 -6.84,-7.5 l 26.83,-306.67 c 0.36,-4.14 4.01,-7.5 8.15,-7.5 4.14,0 7.21,3.36 6.85,7.5 l -26.83,306.67 c -0.37,4.14 -4.01,7.5 -8.16,7.5 m 1027.07,33.33 c -4.14,0 -7.21,-3.36 -6.85,-7.5 l 21.44,-245 c 0.37,-4.14 4.01,-7.5 8.16,-7.5 4.14,0 7.21,3.36 6.84,7.5 l -21.44,245 c -0.36,4.14 -4.01,7.5 -8.15,7.5 m -1036.01,68.88 c -4.14,0 -7.21,-3.36 -6.85,-7.5 l 5.59,-63.88 c 0.37,-4.14 4.02,-7.5 8.16,-7.5 4.14,0 7.21,3.36 6.84,7.5 l -5.59,63.88 c -0.36,4.14 -4.01,7.5 -8.15,7.5 m 1029.99,0 c -4.15,0 -7.21,-3.36 -6.85,-7.5 l 2.14,-24.44 c 0.36,-4.14 4.01,-7.5 8.16,-7.5 4.14,0 7.2,3.36 6.84,7.5 l -2.14,24.44 c -0.36,4.14 -4.01,7.5 -8.15,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    style: {
      fill: "#e2edf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3037.13,1778.48 -60.05,686.4 904.85,79.77 -77.18,-222.62 c -14.4,53.49 -62.95,91.56 -118.82,91.56 -3.6,0 -7.22,-0.15 -10.87,-0.48 -64.44,-5.67 -112.9,-60.38 -112.39,-124.44 -10.24,3.06 -20.93,4.65 -31.72,4.65 -17.31,0 -34.88,-4.09 -51.26,-12.72 -75.55,-39.82 -75.22,-159.65 -51.15,-230.12 3.06,-8.98 7.05,-16.86 11.8,-23.7 l -40,-3.53 1.2,-13.64 -73.02,-6.43 12.1,-138.22 -5.78,66.05 -73.02,-6.43 5.78,-66.06 -7.39,84.47 -73.02,-6.43 7.39,-84.47 73.02,6.43 73.02,6.44 11.72,1.03 c -13.5,-20.58 -26.89,-43.51 -37.81,-63.05 l -277.4,-24.46 m 254.95,600.39 c -3.6,0 -7.23,-0.16 -10.88,-0.48 -67.78,-5.98 -117.88,-66.18 -111.91,-134.49 5.66,-64.62 59.48,-113.32 122.66,-113.32 3.6,0 7.23,0.16 10.88,0.48 67.78,5.97 117.88,66.18 111.91,134.48 -5.66,64.62 -59.48,113.33 -122.66,113.33 m -145.96,27.6 c 0,-0.32 0.02,-0.64 0.04,-0.96 0.49,-5.58 5.14,-9.79 10.6,-9.79 0.31,0 0.62,0.02 0.94,0.04 l 242.09,21.35 c 5.53,0.49 9.7,5.16 9.71,10.65 0,0.32 -0.02,0.64 -0.04,0.96 -0.5,5.58 -5.14,9.79 -10.6,9.79 -0.31,0 -0.63,-0.02 -0.94,-0.05 l -242.09,-21.34 c -5.53,-0.49 -9.7,-5.16 -9.71,-10.65 m 393.86,34.72 c 0,-0.32 0.01,-0.64 0.04,-0.96 0.49,-5.58 5.14,-9.79 10.6,-9.79 0.31,0 0.62,0.02 0.93,0.05 l 242.1,21.34 c 5.53,0.49 9.7,5.16 9.7,10.65 0,0.32 -0.01,0.64 -0.04,0.97 -0.49,5.58 -5.13,9.78 -10.59,9.78 -0.31,0 -0.62,-0.02 -0.94,-0.04 l -242.1,-21.35 c -5.53,-0.49 -9.69,-5.16 -9.7,-10.65 m 268.08,-594.74 v 0 l 102.66,9.06 71.63,206.56 -42.67,487.67 60.05,-686.39 -191.67,-16.9 m -327.38,99.58 -4.54,51.9 v 0 l 4.54,-51.9 v 0 m 213.46,83.22 -1.73,19.76 -69.77,-6.16 c 22.04,35.32 21.12,68.41 19,130.74 13.78,-5.37 28.7,-8.29 44.17,-8.29 3.6,0 7.23,0.16 10.88,0.48 23.28,2.05 44.48,10.5 62.03,23.49 l -55.19,-159.2 -9.39,-0.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    style: {
      fill: "#9faab4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3156.76,2395.72 c -5.46,0 -10.11,4.21 -10.6,9.79 -0.02,0.32 -0.04,0.64 -0.04,0.96 0.01,5.49 4.18,10.16 9.71,10.65 l 242.09,21.34 c 0.31,0.03 0.63,0.05 0.94,0.05 5.46,0 10.1,-4.21 10.6,-9.79 0.02,-0.32 0.04,-0.64 0.04,-0.96 -0.01,-5.49 -4.18,-10.16 -9.71,-10.65 l -242.09,-21.35 c -0.32,-0.02 -0.63,-0.04 -0.94,-0.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    style: {
      fill: "#9faab4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3550.62,2430.44 c -5.46,0 -10.11,4.21 -10.6,9.79 -0.03,0.32 -0.04,0.64 -0.04,0.96 0.01,5.49 4.17,10.16 9.7,10.65 l 242.1,21.35 c 0.32,0.02 0.63,0.04 0.94,0.04 5.46,0 10.1,-4.2 10.59,-9.78 0.03,-0.33 0.04,-0.65 0.04,-0.97 0,-5.49 -4.17,-10.16 -9.7,-10.65 l -242.1,-21.34 c -0.31,-0.03 -0.62,-0.05 -0.93,-0.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3414.74,2265.54 c 5.97,-68.3 -44.13,-128.51 -111.91,-134.48 -67.77,-5.98 -127.56,44.54 -133.54,112.84 -5.97,68.31 44.13,128.51 111.91,134.49 67.77,5.98 127.56,-44.55 133.54,-112.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    style: {
      fill: "#eff5fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3224.08,2189.31 c -3.36,0 -6.23,2.6 -6.53,6.04 l -5.79,66.17 c -0.32,3.64 2.35,6.85 5.97,7.17 l 13.99,1.23 c 0.19,0.02 0.39,0.03 0.58,0.03 3.37,0 6.24,-2.6 6.54,-6.05 l 5.79,-66.16 c 0.32,-3.64 -2.35,-6.85 -5.97,-7.17 l -13.99,-1.23 c -0.2,-0.02 -0.39,-0.03 -0.59,-0.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    style: {
      fill: "#eff5fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3337.15,2191.51 c -0.55,0 -1.1,0.02 -1.65,0.06 l -66.14,4.66 c -5.48,0.38 -9.87,4.73 -10.35,10.25 l -5.2,59.45 c -0.29,3.31 0.83,6.55 3.17,8.88 9.02,8.97 31.6,34.13 31.48,61.24 -0.03,8.33 7.15,13.66 14.16,13.66 4.19,0 8.32,-1.91 10.81,-6.21 5,-8.61 6.18,-25.13 -2.83,-55.97 l 34.56,3.04 c 0.69,0.06 1.37,0.09 2.04,0.09 8.48,0 16.37,-4.66 20.47,-12.26 2.59,-4.8 3.43,-10.35 2.4,-15.71 l -10.1,-52.22 c -2.15,-11.07 -11.78,-18.96 -22.82,-18.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    style: {
      fill: "#fdffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3685.81,2165.3 c -15.47,0 -30.39,2.92 -44.17,8.29 -0.13,3.83 -0.27,7.77 -0.4,11.82 -0.36,17.11 -4.71,33.89 -12.67,49.03 -14.36,27.27 -38.54,46.03 -65.9,54.23 -0.51,64.06 47.95,118.77 112.39,124.44 3.65,0.33 7.27,0.48 10.87,0.48 55.87,0 104.42,-38.07 118.82,-91.56 l -46.03,-132.76 c -17.55,-12.99 -38.75,-21.44 -62.03,-23.49 -3.65,-0.32 -7.28,-0.48 -10.88,-0.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3622.19,2343.28 -13.99,-1.23 c -3.61,-0.32 -6.28,-3.53 -5.96,-7.17 l 5.78,-66.17 c 0.33,-3.64 3.52,-6.33 7.13,-6.02 l 13.99,1.24 c 3.61,0.32 6.29,3.53 5.96,7.17 l -5.78,66.16 c -0.32,3.65 -3.51,6.34 -7.13,6.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3654.87,2263.53 c 10.43,-7.24 37.03,-28.07 41.63,-54.79 2.26,-13.11 21.31,-15.45 25.88,-2.97 3.42,9.36 1.71,25.84 -12.51,54.62 l 34.56,3.05 c 9.24,0.82 17.11,7.08 20.04,15.93 1.72,5.18 1.59,10.79 -0.36,15.89 l -19.01,49.65 c -4.23,11.05 -15.97,17.2 -27.38,14.34 l -64.31,-16.17 c -5.33,-1.34 -8.9,-6.39 -8.42,-11.9 l 5.2,-59.45 c 0.3,-3.31 1.96,-6.31 4.68,-8.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3267.6,1858.52 -73.02,-6.43 -7.39,84.47 73.02,6.43 7.39,-84.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    style: {
      fill: "#fdffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3267.6,1858.52 v 0 l -5.78,66.06 73.02,6.43 5.78,-66.05 -73.02,-6.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "#fdffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3408.71,1927.64 -7.17,81.97 v 0 l -1.2,13.64 40,3.53 c 9.39,-13.53 21.74,-22.98 35.8,-28.85 l 4.54,-51.9 c -14.47,-0.83 -27.84,-1.8 -39.61,-2.79 -11.84,-0.98 -22.02,-6.19 -29.35,-13.98 -1.01,-0.52 -2.01,-1.06 -3.01,-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    style: {
      fill: "#fdffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3623.85,1991.66 c -0.63,0.01 -1.26,0.01 -1.88,0.02 l -9.58,36.65 c 2.67,3.4 5.12,6.76 7.37,10.08 l 4.09,-46.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#fdffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3695.97,2008.27 -1.83,20.98 9.39,0.82 -7.56,-21.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3413.63,1871.4 -73.01,-6.44 -12.1,138.22 73.02,6.43 12.09,-138.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3559.66,1884.27 -73.01,-6.43 -16.46,188.09 73.02,6.44 16.45,-188.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3705.69,1897.15 -73.01,-6.44 -13.29,151.86 73.02,6.44 13.28,-151.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3851.73,1910.03 -73.02,-6.45 -20.64,235.93 73.02,6.44 20.64,-235.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    style: {
      fill: "#e2edf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1947.14,1778.48 -977.452,84.87 -60.051,686.39 760.433,-66.02 -17.35,-50.04 -0.85,8.63 c -0.82,8.38 -8.32,15.7 -16.76,16.34 l -61.32,4.67 c -0.4,0.03 -0.8,0.04 -1.19,0.04 -7.81,0 -13.37,-6.07 -12.58,-14.06 l 5.01,-51.02 c 0.33,-3.33 1.71,-6.49 3.79,-9.13 l -499.23,43.34 c -1.19,0.11 -2.36,0.16 -3.52,0.16 -20.29,0 -34.83,-15.64 -33.02,-36.39 l 6.62,-75.58 c 1.91,-21.94 21.38,-41.27 43.48,-43.19 l 500.36,-43.44 -9.39,-27.09 -361.15,31.36 c -1.2,0.11 -2.37,0.16 -3.53,0.16 -20.28,0 -34.83,-15.64 -33.01,-36.39 l 6.61,-75.58 c 1.92,-21.94 21.39,-41.27 43.49,-43.19 l 295.82,-25.68 -13.54,-39.06 -364.39,31.64 c -1.19,0.11 -2.36,0.16 -3.52,0.16 -20.28,0 -34.83,-15.64 -33.02,-36.39 l 6.62,-75.59 c 1.92,-21.93 21.39,-41.26 43.48,-43.18 l 299.06,-25.96 -16.23,-46.81 259.89,-22.57 195.29,563.28 -8.9,101.72 -62.51,5.43 62.51,-5.43 60.05,-686.4 m -317.88,587.53 c -1.95,2.76 -4.18,5.34 -6.63,7.67 l 2.78,5.1 8.06,-0.64 -4.21,-12.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1607.72,2231.95 -524.57,45.54 c -22.1,1.92 -41.57,21.25 -43.48,43.19 l -6.62,75.58 c -1.91,21.93 14.44,38.15 36.54,36.23 l 524.57,-45.54 c 22.1,-1.92 41.56,-21.25 43.49,-43.18 l 6.61,-75.59 c 1.92,-21.93 -14.44,-38.15 -36.54,-36.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1169.87,2346.87 c 2.3,-26.23 -17.27,-45.63 -43.71,-43.34 -26.43,2.3 -49.72,25.42 -52.01,51.66 -2.3,26.23 17.27,45.64 43.7,43.34 26.44,-2.29 49.73,-25.42 52.02,-51.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1231.13,2368.23 c -5.74,0.5 -10.8,5.52 -11.29,11.21 -0.5,5.7 3.75,9.91 9.49,9.41 l 321.5,-27.91 c 5.74,-0.5 10.8,-5.52 11.3,-11.22 0.49,-5.69 -3.75,-9.9 -9.5,-9.41 l -321.5,27.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1237.64,2293.85 c -5.74,0.5 -10.8,5.52 -11.3,11.22 -0.49,5.69 3.76,9.91 9.49,9.4 l 188.31,-16.34 c 5.74,-0.5 10.79,-5.52 11.29,-11.22 0.5,-5.69 -3.75,-9.9 -9.49,-9.41 l -188.3,16.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1234.38,2331.04 c -5.74,0.5 -10.79,5.52 -11.29,11.21 -0.5,5.7 3.75,9.91 9.49,9.41 l 272.69,-23.67 c 5.74,-0.5 10.8,-5.52 11.3,-11.21 0.5,-5.7 -3.75,-9.92 -9.49,-9.42 l -272.7,23.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1553.55,2340.27 c -0.3,0 -0.61,0.02 -0.92,0.04 l -321.5,27.92 c -5.74,0.5 -10.8,5.52 -11.29,11.21 -0.03,0.3 -0.04,0.59 -0.04,0.87 -0.02,4.95 3.63,8.58 8.61,8.58 0.3,0 0.61,-0.01 0.92,-0.04 l 321.5,-27.91 c 5.74,-0.5 10.8,-5.52 11.3,-11.22 0.02,-0.29 0.03,-0.58 0.04,-0.87 0.01,-4.95 -3.64,-8.58 -8.62,-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1426.86,2277.46 c -0.3,0 -0.61,0.02 -0.92,0.04 l -188.3,16.35 c -5.74,0.5 -10.8,5.52 -11.3,11.22 -0.02,0.29 -0.03,0.58 -0.03,0.87 -0.02,4.95 3.63,8.58 8.6,8.58 0.3,0 0.61,-0.02 0.92,-0.05 l 188.31,-16.34 c 5.74,-0.5 10.79,-5.52 11.29,-11.22 0.03,-0.29 0.04,-0.58 0.04,-0.87 0.01,-4.95 -3.63,-8.58 -8.61,-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1508,2307.32 c -0.3,0 -0.61,0.01 -0.92,0.04 l -272.7,23.68 c -5.74,0.5 -10.79,5.52 -11.29,11.21 -0.02,0.3 -0.04,0.59 -0.04,0.88 -0.01,4.95 3.64,8.57 8.62,8.57 0.3,0 0.6,-0.01 0.91,-0.04 l 272.69,-23.67 c 5.74,-0.5 10.8,-5.52 11.3,-11.21 0.02,-0.3 0.04,-0.59 0.04,-0.88 0.01,-4.95 -3.64,-8.58 -8.61,-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1635.11,2458.65 -61.32,4.67 c -8.43,0.64 -14.6,-5.63 -13.77,-14.02 l 5.01,-51.02 c 0.82,-8.36 8.29,-15.66 16.7,-16.33 l 17.75,-1.41 8.71,-12.45 c 2.95,-4.22 8.87,-4.64 10.97,-0.77 l 6.25,11.46 17.64,-1.4 c 8.46,-0.67 14.65,5.61 13.83,14.01 l -5.01,50.92 c -0.82,8.38 -8.32,15.7 -16.76,16.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    style: {
      fill: "#eff5fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1610.69,2394.7 -22.75,22.5 c -5.28,5.17 -7.85,10.54 -8.25,15.19 -0.65,7.42 3.56,12.12 10.73,12.12 0.49,0 1,-0.02 1.52,-0.07 7.53,-0.65 10.4,-4.34 15.25,-9.73 3.63,4.23 5.84,7.3 11.93,7.3 0.58,0 1.19,-0.03 1.84,-0.09 8.08,-0.7 13.87,-6.45 14.56,-14.38 0.41,-4.64 -1.25,-9.66 -5.7,-13.97 l -19.13,-18.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1751.1,2037.78 -524.57,45.54 c -22.1,1.92 -41.57,21.25 -43.49,43.19 l -6.61,75.58 c -1.92,21.93 14.44,38.15 36.54,36.23 l 524.57,-45.54 c 22.09,-1.92 41.56,-21.25 43.48,-43.18 l 6.61,-75.59 c 1.92,-21.93 -14.43,-38.15 -36.53,-36.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1313.25,2152.7 c 2.29,-26.23 -17.28,-45.63 -43.71,-43.34 -26.43,2.3 -49.72,25.42 -52.02,51.66 -2.29,26.23 17.28,45.64 43.71,43.34 26.43,-2.29 49.72,-25.42 52.02,-51.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1374.5,2174.06 c -5.73,0.5 -10.79,5.52 -11.29,11.21 -0.5,5.7 3.75,9.91 9.49,9.41 l 321.51,-27.91 c 5.73,-0.5 10.79,-5.52 11.29,-11.22 0.5,-5.69 -3.75,-9.9 -9.49,-9.4 l -321.51,27.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1381.01,2099.68 c -5.73,0.5 -10.79,5.52 -11.29,11.22 -0.5,5.69 3.75,9.91 9.49,9.4 l 188.3,-16.34 c 5.74,-0.5 10.8,-5.52 11.3,-11.22 0.49,-5.69 -3.75,-9.91 -9.49,-9.41 l -188.31,16.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1377.76,2136.87 c -5.74,0.5 -10.8,5.52 -11.29,11.21 -0.5,5.7 3.75,9.91 9.48,9.41 l 272.7,-23.67 c 5.74,-0.5 10.8,-5.52 11.29,-11.21 0.5,-5.7 -3.75,-9.92 -9.48,-9.42 l -272.7,23.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1557.21,2158.19 -182.71,15.87 c -5.73,0.5 -10.79,5.52 -11.29,11.21 -0.03,0.3 -0.04,0.59 -0.04,0.87 -0.01,4.95 3.63,8.58 8.61,8.58 0.3,0 0.61,-0.01 0.92,-0.04 l 191.4,-16.61 -6.89,-19.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1532.37,2086.54 -151.36,13.14 c -5.73,0.5 -10.79,5.52 -11.29,11.22 -0.03,0.29 -0.04,0.58 -0.04,0.87 -0.02,4.95 3.63,8.58 8.6,8.58 0.31,0 0.61,-0.02 0.93,-0.05 l 160.05,-13.89 -6.89,-19.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1544.79,2122.37 -167.03,14.5 c -5.74,0.5 -10.8,5.52 -11.29,11.21 -0.03,0.3 -0.04,0.59 -0.04,0.88 -0.02,4.95 3.63,8.57 8.61,8.57 0.3,0 0.6,-0.01 0.91,-0.04 l 175.73,-15.25 -6.89,-19.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1778.49,2264.48 -61.33,4.67 c -8.43,0.64 -14.6,-5.63 -13.77,-14.02 l 5.02,-51.02 c 0.82,-8.36 8.29,-15.66 16.7,-16.33 l 17.75,-1.41 8.7,-12.45 c 2.95,-4.22 8.87,-4.63 10.98,-0.77 l 6.24,11.46 17.65,-1.4 c 8.45,-0.67 14.65,5.61 13.82,14.01 l -5,50.92 c -0.83,8.38 -8.33,15.7 -16.76,16.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1682.55,1849.68 -524.57,45.54 c -22.09,1.92 -41.56,21.25 -43.48,43.18 l -6.62,75.59 c -1.92,21.93 14.45,38.15 36.54,36.23 l 524.57,-45.54 c 22.1,-1.92 41.57,-21.25 43.49,-43.18 l 6.61,-75.59 c 1.92,-21.93 -14.44,-38.15 -36.54,-36.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1244.7,1964.6 c 2.3,-26.23 -17.27,-45.64 -43.7,-43.34 -26.44,2.29 -49.73,25.42 -52.02,51.65 -2.3,26.24 17.27,45.64 43.71,43.35 26.43,-2.3 49.72,-25.42 52.01,-51.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1305.96,1985.96 c -5.74,0.49 -10.79,5.51 -11.29,11.21 -0.5,5.69 3.75,9.91 9.49,9.41 l 321.5,-27.91 c 5.74,-0.5 10.8,-5.52 11.29,-11.22 0.5,-5.69 -3.75,-9.91 -9.48,-9.41 l -321.51,27.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1312.47,1911.58 c -5.74,0.5 -10.8,5.52 -11.3,11.21 -0.49,5.7 3.75,9.91 9.5,9.41 l 258.83,-22.47 c 5.75,-0.49 10.8,-5.51 11.3,-11.22 0.5,-5.69 -3.75,-9.9 -9.49,-9.4 l -258.84,22.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1309.22,1948.77 c -5.74,0.5 -10.8,5.51 -11.3,11.21 -0.5,5.7 3.75,9.91 9.49,9.41 l 232.39,-20.17 c 5.74,-0.5 10.8,-5.53 11.3,-11.22 0.49,-5.69 -3.75,-9.91 -9.49,-9.41 l -232.39,20.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1491.9,1969.81 -185.94,16.15 c -5.74,0.49 -10.79,5.51 -11.29,11.21 -0.03,0.3 -0.04,0.59 -0.04,0.87 -0.01,4.95 3.63,8.58 8.61,8.58 0.3,0 0.61,-0.01 0.92,-0.04 l 194.63,-16.9 -6.89,-19.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1467.06,1898.16 -154.59,13.42 c -5.74,0.5 -10.8,5.52 -11.3,11.21 -0.02,0.3 -0.03,0.59 -0.04,0.87 -0.01,4.95 3.64,8.58 8.62,8.58 0.3,0 0.61,-0.01 0.92,-0.04 l 163.28,-14.17 -6.89,-19.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1479.48,1933.99 -170.26,14.78 c -5.74,0.5 -10.8,5.51 -11.3,11.21 -0.02,0.3 -0.04,0.59 -0.04,0.87 -0.01,4.95 3.64,8.58 8.62,8.58 0.3,0 0.6,-0.01 0.91,-0.04 l 178.96,-15.53 -6.89,-19.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1711.71,2056.22 -61.33,4.67 c -8.43,0.64 -14.59,-5.63 -13.77,-14.02 l 5.02,-51.02 c 0.82,-8.36 8.29,-15.66 16.7,-16.33 l 17.75,-1.41 8.7,-12.45 c 2.96,-4.22 8.87,-4.64 10.98,-0.77 l 6.24,11.46 17.65,-1.4 c 8.45,-0.67 14.65,5.61 13.82,14.01 l -5.01,50.92 c -0.82,8.38 -8.32,15.69 -16.75,16.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    style: {
      fill: "#e2edf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2977.38,1775.86 h -308.27 l 144.01,415.36 c 28.8,0.7 49.91,24.32 47.37,53.35 -1.19,13.61 -7.37,26.03 -16.58,35.46 l 63.17,182.22 h -267.71 l -47.91,-138.17 c -45.35,27.58 -97.84,43.57 -152.66,43.57 v 0 c -1.57,0 -3.13,-0.01 -4.68,-0.03 -0.67,-0.02 -1.33,-0.03 -1.99,-0.04 -40.22,-0.96 -77.54,-10.56 -110.34,-27.02 -35.87,-18.01 -66.33,-44.22 -89.26,-76.31 -5.23,1.25 -10.63,1.91 -16.13,1.91 -37.03,0 -64.43,-30.02 -61.18,-67.05 1.94,-22.28 14.54,-42.02 32.33,-54.21 -1.01,-9.44 -1.53,-19.04 -1.53,-28.8 0,-8 0.36,-16.1 1.07,-24.28 v 0 c 1.14,-12.99 3.15,-25.77 5.99,-38.28 -21.29,-10.91 -34.6,-33.78 -32.29,-60.23 3.24,-37.02 35.89,-67.04 72.92,-67.04 7.2,0 14.05,1.13 20.37,3.24 41.78,-51.17 99.57,-89.02 164.16,-105.06 l -16.85,-48.59 h -394.04 l -60.05,686.39 h 970.03 l 60.05,-686.39 m -163.77,394.52 c -5.69,0 -9.91,-4.61 -9.4,-10.31 l 11.86,-135.62 c 0.5,-5.7 5.52,-10.32 11.21,-10.32 5.7,0 9.91,4.62 9.42,10.32 l -11.87,135.62 c -0.5,5.7 -5.52,10.31 -11.22,10.31 m -798.08,171.01 c 0,-0.3 0.02,-0.61 0.04,-0.92 0.5,-5.7 5.53,-10.32 11.22,-10.32 h 195.62 c 5.39,0 9.45,4.13 9.45,9.39 0,0.31 -0.01,0.61 -0.04,0.93 -0.5,5.69 -5.51,10.31 -11.21,10.31 h -195.62 c -5.39,0 -9.45,-4.13 -9.46,-9.39 m -3.25,37.19 c 0,-0.31 0.01,-0.61 0.04,-0.93 0.5,-5.69 5.52,-10.31 11.22,-10.31 h 155.62 c 5.38,0 9.44,4.12 9.45,9.39 0,0.3 -0.01,0.61 -0.04,0.92 -0.5,5.7 -5.52,10.32 -11.21,10.32 h -155.63 c -5.38,0 -9.44,-4.13 -9.45,-9.39 m -3.25,37.18 c 0,-0.3 0.01,-0.61 0.04,-0.92 0.5,-5.7 5.52,-10.31 11.21,-10.31 h 235.63 c 5.38,0 9.44,4.12 9.45,9.39 0,0.3 -0.01,0.61 -0.04,0.92 -0.5,5.69 -5.52,10.31 -11.22,10.31 h -235.62 c -5.39,0 -9.44,-4.12 -9.45,-9.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    style: {
      fill: "#4b70c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1977.09,1779.05 c -4.14,0 -7.79,3.36 -8.15,7.5 l -18.91,216.13 c -0.36,4.14 2.7,7.5 6.84,7.5 4.14,0 7.8,-3.36 8.16,-7.5 l 18.91,-216.13 c 0.36,-4.14 -2.71,-7.5 -6.85,-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    style: {
      fill: "#4b70c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1954.68,2035.18 c -4.14,0 -7.79,3.36 -8.15,7.5 l -26.83,306.67 c -0.37,4.14 2.7,7.5 6.84,7.5 4.15,0 7.79,-3.36 8.16,-7.5 l 26.83,-306.67 c 0.36,-4.14 -2.71,-7.5 -6.85,-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    style: {
      fill: "#4b70c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1924.5,2380.18 c -4.14,0 -7.79,3.36 -8.16,7.5 l -5.59,63.88 c -0.36,4.14 2.71,7.5 6.85,7.5 4.14,0 7.79,-3.36 8.15,-7.5 l 5.59,-63.88 c 0.37,-4.14 -2.7,-7.5 -6.84,-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    style: {
      fill: "#4b70c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3007.08,1779.05 c -4.14,0 -7.8,3.36 -8.16,7.5 l -27.51,314.46 c -0.36,4.14 2.7,7.5 6.84,7.5 4.14,0 7.8,-3.36 8.16,-7.5 l 27.51,-314.46 c 0.36,-4.14 -2.7,-7.5 -6.84,-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    style: {
      fill: "#4b70c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2976.36,2130.18 c -4.15,0 -7.79,3.36 -8.16,7.5 l -21.44,245 c -0.36,4.14 2.71,7.5 6.85,7.5 4.14,0 7.79,-3.36 8.15,-7.5 l 21.44,-245 c 0.37,-4.14 -2.7,-7.5 -6.84,-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    style: {
      fill: "#4b70c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2951.04,2419.62 c -4.15,0 -7.8,3.36 -8.16,7.5 l -2.14,24.44 c -0.36,4.14 2.7,7.5 6.85,7.5 4.14,0 7.79,-3.36 8.15,-7.5 l 2.14,-24.44 c 0.36,-4.14 -2.7,-7.5 -6.84,-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2804.21,2160.07 c -0.51,5.7 3.71,10.31 9.4,10.31 5.7,0 10.72,-4.61 11.22,-10.31 l 11.87,-135.62 c 0.49,-5.7 -3.72,-10.32 -9.42,-10.32 -5.69,0 -10.71,4.62 -11.21,10.32 l -11.86,135.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2020.28,2404.53 c -5.69,0 -10.71,4.61 -11.21,10.31 -0.5,5.69 3.71,10.31 9.41,10.31 h 235.62 c 5.7,0 10.72,-4.62 11.22,-10.31 0.5,-5.7 -3.72,-10.31 -9.41,-10.31 h -235.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2026.79,2330.15 c -5.69,0 -10.72,4.62 -11.22,10.32 -0.49,5.69 3.72,10.31 9.42,10.31 h 195.62 c 5.7,0 10.71,-4.62 11.21,-10.31 0.5,-5.7 -3.71,-10.32 -9.41,-10.32 h -195.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2023.54,2367.34 c -5.7,0 -10.72,4.62 -11.22,10.31 -0.5,5.7 3.72,10.32 9.41,10.32 h 155.63 c 5.69,0 10.71,-4.62 11.21,-10.32 0.5,-5.69 -3.71,-10.31 -9.41,-10.31 h -155.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2255.91,2404.53 h -235.63 c -5.69,0 -10.71,4.61 -11.21,10.31 -0.03,0.31 -0.04,0.62 -0.04,0.92 0.01,5.27 4.06,9.39 9.45,9.39 h 235.62 c 5.7,0 10.72,-4.62 11.22,-10.31 0.03,-0.31 0.04,-0.62 0.04,-0.92 -0.01,-5.27 -4.07,-9.39 -9.45,-9.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2222.41,2330.15 h -195.62 c -5.69,0 -10.72,4.62 -11.22,10.32 -0.02,0.31 -0.04,0.62 -0.04,0.92 0.01,5.26 4.07,9.39 9.46,9.39 h 195.62 c 5.7,0 10.71,-4.62 11.21,-10.31 0.03,-0.32 0.04,-0.62 0.04,-0.93 0,-5.26 -4.06,-9.39 -9.45,-9.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2179.16,2367.34 h -155.62 c -5.7,0 -10.72,4.62 -11.22,10.31 -0.03,0.32 -0.04,0.62 -0.04,0.93 0.01,5.26 4.07,9.39 9.45,9.39 h 155.63 c 5.69,0 10.71,-4.62 11.21,-10.32 0.03,-0.31 0.04,-0.62 0.04,-0.92 -0.01,-5.27 -4.07,-9.39 -9.45,-9.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2860.49,2244.57 c 2.58,-29.47 -19.22,-53.37 -48.7,-53.37 -29.47,0 -55.46,23.9 -58.03,53.37 -2.58,29.48 19.22,53.37 48.69,53.37 29.48,0 55.46,-23.89 58.04,-53.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2780.86,2219.11 c -3.25,0 -6.12,2.64 -6.4,5.89 l -1.97,22.47 c -0.28,3.25 2.13,5.89 5.38,5.89 3.25,0 6.12,-2.64 6.4,-5.89 l 1.97,-22.47 c 0.28,-3.25 -2.13,-5.89 -5.38,-5.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2791.9,2254.5 c 3.92,3.5 13.74,13.42 13.7,25.03 -0.02,5.7 7.97,7.43 10.86,2.25 2.17,-3.88 2.68,-11 -1.25,-23.86 h 15.03 c 4.02,0 7.86,-2.39 9.79,-6.07 1.12,-2.15 1.48,-4.56 1.04,-6.81 l -4.41,-21.98 c -0.98,-4.89 -5.55,-7.97 -10.65,-7.17 l -28.75,4.49 c -2.39,0.37 -4.29,2.4 -4.5,4.78 l -2.25,25.65 c -0.12,1.43 0.37,2.78 1.39,3.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2887.14,1939.95 c -2.58,29.47 -28.56,53.36 -58.03,53.36 -29.48,0 -51.28,-23.89 -48.7,-53.36 2.58,-29.47 28.56,-53.37 58.03,-53.37 29.48,0 51.28,23.9 48.7,53.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2803.06,1965.41 v 0 c -3.25,0 -5.66,-2.64 -5.37,-5.89 l 1.96,-22.47 c 0.29,-3.25 3.15,-5.89 6.41,-5.89 3.25,0 5.65,2.64 5.37,5.89 l -1.97,22.47 c -0.28,3.25 -3.15,5.89 -6.4,5.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2820.29,1930.02 c 4.53,-3.5 16.09,-13.42 18.08,-25.03 0.98,-5.71 9.26,-7.42 11.26,-2.25 1.49,3.88 0.75,11 -5.43,23.86 h 15.03 c 4.01,0 7.44,2.38 8.72,6.07 0.75,2.15 0.69,4.56 -0.16,6.81 l -8.25,21.98 c -1.83,4.9 -6.94,7.97 -11.9,7.18 l -27.97,-4.5 c -2.31,-0.37 -3.87,-2.4 -3.66,-4.78 l 2.24,-25.65 c 0.13,-1.43 0.85,-2.78 2.04,-3.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2738.76,2091.82 c 13.33,-152.34 -99.36,-275.84 -251.7,-275.84 -152.34,0 -286.64,123.5 -299.97,275.84 -13.32,152.34 99.37,275.83 251.71,275.83 152.33,0 286.63,-123.49 299.96,-275.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    style: {
      fill: "#b4caec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2462.93,2091.82 v 0 l -24.13,275.83 v 0 0 c 54.82,0 107.31,-15.99 152.66,-43.57 l -3.18,-9.18 c -16.15,-12.14 -25.64,-32.17 -23.66,-54.83 0.27,-3.14 0.76,-6.23 1.44,-9.25 l -25.7,-74.15 -77.43,-84.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    style: {
      fill: "#b4caec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2462.93,2091.82 h -275.84 v 0 c -0.71,8.18 -1.07,16.28 -1.07,24.28 0,9.76 0.52,19.36 1.53,28.8 11.78,-8.07 25.83,-12.83 40.58,-12.83 37.03,0 64.42,30.02 61.18,67.04 -2.76,31.53 -26.83,57.97 -56.78,65.14 22.93,32.09 53.39,58.3 89.26,76.31 -27.03,-13.57 -50.99,-31.8 -70.97,-53.7 v 0 0 0 l 212.11,-195.04 m -30.8,275.76 c 0.66,0.01 1.32,0.02 1.99,0.04 -0.67,-0.02 -1.33,-0.03 -1.99,-0.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2250.82,2286.86 212.11,-195.04 -24.13,275.83 c -76.18,0 -142.43,-30.87 -187.98,-80.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    style: {
      fill: "#2e53ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2462.93,2091.82 -212.11,195.04 c 45.55,49.92 111.8,80.79 187.98,80.79 l 24.13,-275.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    style: {
      fill: "#799bd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2418.24,1824.45 c -49.9,12.39 -95.75,37.81 -133.29,72.33 l 177.98,195.04 h 48.01 l -92.7,-267.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2667.57,1863.14 c 3.23,-37.03 -24.16,-67.05 -61.19,-67.05 -37.02,0 -69.67,30.02 -72.91,67.05 -3.24,37.03 24.15,67.05 61.18,67.05 37.03,0 69.67,-30.02 72.92,-67.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2577.24,1851.99 c -6.12,5.53 -9.1,11.59 -9.58,17.01 -0.8,9.26 4.83,15.43 14.19,15.43 8.72,0 12.05,-4.04 17.67,-9.89 4.6,5.85 7.22,9.89 15.95,9.89 9.36,0 16.07,-6.17 16.87,-15.43 0.48,-5.42 -1.43,-11.48 -6.59,-17.01 l -22.15,-24.15 -26.36,24.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2289.31,2199.11 c 3.24,-37.02 -24.15,-67.04 -61.18,-67.04 -37.03,0 -69.68,30.02 -72.91,67.04 -3.25,37.03 24.15,67.05 61.18,67.05 37.02,0 69.67,-30.02 72.91,-67.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2264.49,2199.11 c 2.04,-23.32 -15.21,-42.23 -38.53,-42.23 -23.33,0 -43.89,18.91 -45.93,42.23 -2.04,23.33 15.22,42.24 38.54,42.24 23.32,0 43.88,-18.91 45.92,-42.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2225.96,2156.88 c -23.33,0 -43.89,18.91 -45.93,42.23 -0.11,1.28 -0.16,2.54 -0.16,3.79 0.03,21.55 16.65,38.45 38.7,38.45 23.32,0 43.88,-18.91 45.92,-42.24 0.12,-1.27 0.17,-2.53 0.17,-3.78 -0.03,-21.55 -16.66,-38.45 -38.7,-38.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2237.73,2190.16 c -7.9,-7.92 -20.07,-7.94 -29.37,0 -3.7,3.16 -8.4,-1.95 -4.68,-5.13 12.47,-10.65 29.02,-10.65 39.63,0 3.17,3.17 -2.42,8.3 -5.58,5.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2210.97,2212.87 c 0.4,-4.6 -0.88,-8.32 -2.85,-8.32 -1.98,0 -3.91,3.72 -4.31,8.32 -0.4,4.59 0.87,8.31 2.85,8.31 1.98,0 3.91,-3.72 4.31,-8.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2238.31,2212.87 c 0.4,-4.6 -0.87,-8.32 -2.85,-8.32 -1.98,0 -3.91,3.72 -4.31,8.32 -0.4,4.59 0.87,8.31 2.85,8.31 1.98,0 3.91,-3.72 4.31,-8.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2698.71,2260.07 c 3.24,-37.04 -24.15,-67.05 -61.18,-67.05 -37.03,0 -69.67,30.01 -72.91,67.05 -3.24,37.02 24.15,67.04 61.18,67.04 37.03,0 69.67,-30.02 72.91,-67.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2673.9,2260.07 c 2.04,-23.33 -15.22,-42.24 -38.54,-42.24 -23.32,0 -43.88,18.91 -45.92,42.24 -2.05,23.32 15.2,42.23 38.53,42.23 23.33,0 43.89,-18.91 45.93,-42.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2618.83,2238.99 c 7.89,7.92 20.06,7.94 29.37,0 3.7,-3.17 8.4,1.95 4.68,5.13 -12.48,10.65 -29.03,10.65 -39.64,0 -3.16,-3.18 2.43,-8.3 5.59,-5.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2620.37,2273.82 c 0.4,-4.59 -0.87,-8.32 -2.85,-8.32 -1.98,0 -3.91,3.73 -4.31,8.32 -0.4,4.59 0.88,8.32 2.86,8.32 1.97,0 3.9,-3.73 4.3,-8.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2647.71,2273.82 c 0.41,-4.59 -0.87,-8.32 -2.85,-8.32 -1.98,0 -3.91,3.73 -4.31,8.32 -0.4,4.59 0.88,8.32 2.85,8.32 1.98,0 3.91,-3.73 4.31,-8.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2294.88,1993.31 c 3.25,-37.02 -24.15,-67.04 -61.17,-67.04 -37.03,0 -69.68,30.02 -72.92,67.04 -3.23,37.03 24.16,67.05 61.18,67.05 37.03,0 69.68,-30.02 72.91,-67.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2270.07,1993.31 c 2.04,-23.32 -15.21,-42.23 -38.54,-42.23 -23.32,0 -43.88,18.91 -45.92,42.23 -2.04,23.33 15.21,42.23 38.54,42.23 23.32,0 43.88,-18.9 45.92,-42.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2231.53,1951.08 c -23.32,0 -43.88,18.91 -45.92,42.23 -0.11,1.28 -0.16,2.54 -0.16,3.79 0.03,21.55 16.65,38.44 38.7,38.44 23.32,0 43.88,-18.9 45.92,-42.23 0.11,-1.27 0.17,-2.53 0.16,-3.78 -0.02,-21.55 -16.65,-38.45 -38.7,-38.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2208.05,1979.92 c 12.59,-11.57 31.36,-11.57 41.92,0 l -0.62,7.06 h -41.91 l 0.61,-7.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2222.26,2005.98 c -6.14,4.86 -13.11,4.86 -18.4,0 -2.47,-2.28 1.73,-6.11 4.19,-3.85 3.13,2.88 7.06,2.88 10.7,0 2.85,-2.26 6.38,1.57 3.51,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2249.6,2005.98 c -6.14,4.86 -13.1,4.86 -18.39,0 -2.48,-2.28 1.72,-6.11 4.18,-3.85 3.13,2.88 7.06,2.88 10.7,0 2.85,-2.26 6.38,1.57 3.51,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2988.82,1514.31 h -310.13 v -50.42 h 620.26 v 20.73 l -310.13,29.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    style: {
      fill: "#b4caec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3298.95,1463.89 h -310.13 v 20.73 l -310.13,29.69 v -50.42 50.42 h 198.38 111.75 l 43.12,-4.12 c 39.97,-13.52 118.53,-38 163.02,-38 4.73,0 9.07,0.28 12.94,0.87 7.64,1.18 17.64,7.5 29.18,17.48 l 61.87,-5.92 v -20.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    style: {
      fill: "#e3edf9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2988.82,1463.89 h -310.13 v 50.42 l 310.13,-29.69 v -20.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    style: {
      fill: "#b4caec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3881.94,2544.66 v 0 l 57.74,5.08 -57.75,-5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    style: {
      fill: "#f3f8fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3808.06,1846.45 c -12.1,23.14 -25.55,42.3 -40.48,56.15 l 11.13,0.98 73.02,6.45 -20.64,235.92 -73.02,-6.44 9.08,-103.82 -63.62,-5.62 55.19,159.2 c 33.55,24.81 53.8,66.16 49.88,111 -0.66,7.48 -1.96,14.75 -3.85,21.76 l 77.19,222.63 57.74,5.08 42.67,-487.67 -71.63,-206.56 -102.66,-9.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3758.72,2189.27 46.03,132.76 c 1.89,-7.01 3.19,-14.28 3.85,-21.76 3.92,-44.84 -16.33,-86.19 -49.88,-111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3767.58,1902.6 c -0.17,0.16 -0.33,0.31 -0.5,0.46 -15.06,13.83 -37.72,23.71 -64.58,30.62 l -6.53,74.59 7.56,21.8 63.62,5.62 11.56,-132.11 -11.13,-0.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3702.5,1933.68 c -4.86,1.26 -9.86,2.41 -14.98,3.47 -1.76,5.03 -4.74,12.39 -9.25,20.07 l 17.7,51.05 6.53,-74.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3778.71,1903.58 v 0 l -11.56,132.11 -9.08,103.82 73.02,6.44 20.64,-235.92 -73.02,-6.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    style: {
      fill: "#f3f8fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2669.11,1775.86 h -267.72 l 16.85,48.59 c 22.26,-5.53 45.32,-8.47 68.82,-8.47 v 0 c 21.9,0 42.96,2.55 62.97,7.38 13.65,-16.54 34.22,-27.27 56.35,-27.27 37.03,0 64.42,30.02 61.19,67.05 -0.64,7.27 -2.41,14.27 -5.12,20.82 53.1,50.2 83.13,123.87 76.46,206.07 -0.05,0.6 -0.1,1.19 -0.15,1.79 -4.26,48.65 -20.85,94.36 -46.43,134.04 5.08,10.01 7.47,21.71 6.38,34.21 -3.24,37.02 -35.88,67.04 -72.91,67.04 -10.44,0 -20.11,-2.38 -28.55,-6.64 -1.92,1.23 -3.84,2.43 -5.79,3.61 l 47.91,138.17 h 267.71 l -63.17,-182.22 c -10.74,10.99 -25.59,17.91 -41.46,17.91 -29.47,0 -51.27,-23.89 -48.69,-53.37 2.57,-29.47 28.56,-53.37 58.03,-53.37 0.45,0 0.89,0.01 1.33,0.02 l -144.01,-415.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2811.79,2191.2 c -29.47,0 -55.46,23.9 -58.03,53.37 -2.58,29.48 19.22,53.37 48.69,53.37 15.87,0 30.72,-6.92 41.46,-17.91 l -8.2,-23.64 c -1.65,0.98 -3.54,1.53 -5.47,1.53 h -15.03 c 3.93,12.86 3.42,19.98 1.25,23.86 -1.19,2.13 -3.24,3.09 -5.24,3.09 -2.86,0 -5.63,-1.98 -5.62,-5.34 0.04,-11.61 -9.78,-21.53 -13.7,-25.03 -1.02,-0.91 -1.51,-2.26 -1.39,-3.69 l 2.25,-25.65 c 0.21,-2.38 2.11,-4.41 4.5,-4.78 l 24.63,-3.85 -8.77,-25.31 c -0.44,-0.01 -0.88,-0.02 -1.33,-0.02 m -33.92,62.16 c -3.25,0 -5.66,-2.64 -5.38,-5.89 l 1.97,-22.47 c 0.28,-3.25 3.15,-5.89 6.4,-5.89 3.25,0 5.66,2.64 5.38,5.89 l -1.97,22.47 c -0.28,3.25 -3.15,5.89 -6.4,5.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2780.86,2219.11 c -3.25,0 -6.12,2.64 -6.4,5.89 l -1.97,22.47 c -0.28,3.25 2.13,5.89 5.38,5.89 3.25,0 6.12,-2.64 6.4,-5.89 l 1.97,-22.47 c 0.28,-3.25 -2.13,-5.89 -5.38,-5.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2821.89,2216.53 -24.63,3.85 c -2.39,0.37 -4.29,2.4 -4.5,4.78 l -2.25,25.65 c -0.12,1.43 0.37,2.78 1.39,3.69 3.92,3.5 13.74,13.42 13.7,25.03 -0.01,3.36 2.76,5.34 5.62,5.34 2,0 4.05,-0.96 5.24,-3.09 2.17,-3.88 2.68,-11 -1.25,-23.86 h 15.03 c 1.93,0 3.82,-0.55 5.47,-1.53 l -13.82,-39.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2487.06,1815.98 c -23.5,0 -46.56,2.94 -68.82,8.47 v 0 c 22.26,-5.53 45.32,-8.47 68.82,-8.47 m 251.85,274.05 c -0.05,0.6 -0.1,1.19 -0.15,1.79 h -227.82 l 29.42,84.85 40.33,44.2 c 13.65,-16.87 34.44,-27.85 56.84,-27.85 24.53,0 44.84,13.18 54.8,32.84 25.58,-39.68 42.17,-85.39 46.43,-134.04 0.05,-0.6 0.1,-1.19 0.15,-1.79 m -141.66,230.44 c -1.91,1.22 -3.85,2.43 -5.79,3.61 v 0 c 1.95,-1.18 3.87,-2.38 5.79,-3.61 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    style: {
      fill: "#dbe8f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2540.36,2176.67 25.7,74.15 c 2.5,-11.08 7.62,-21.29 14.63,-29.95 l -40.33,-44.2 m 47.92,138.23 3.18,9.18 c 1.94,-1.18 3.88,-2.39 5.79,-3.61 -3.17,-1.6 -6.17,-3.47 -8.97,-5.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    style: {
      fill: "#f6fafe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2487.06,1815.98 v 0 0 c 21.89,0 42.96,2.55 62.97,7.38 v 0 c -20.01,-4.83 -41.07,-7.38 -62.97,-7.38 m 175.39,67.98 v 0 c 53.1,50.21 83.13,123.87 76.46,206.07 6.67,-82.2 -23.36,-155.87 -76.46,-206.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    style: {
      fill: "#bfd3ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2487.06,1815.98 v 0 c -23.5,0 -46.56,2.94 -68.82,8.47 l 92.7,267.37 h 227.82 c 0.05,-0.6 0.1,-1.19 0.15,-1.79 6.67,-82.2 -23.36,-155.86 -76.46,-206.07 -11.11,26.84 -38.04,46.23 -67.8,46.23 -37.03,0 -64.42,-30.02 -61.18,-67.05 1.31,-14.89 7.37,-28.66 16.56,-39.78 -20.01,-4.83 -41.08,-7.38 -62.97,-7.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2606.38,1796.09 c -22.13,0 -42.7,10.73 -56.35,27.27 v 0 c -9.19,11.12 -15.25,24.89 -16.56,39.78 -3.24,37.03 24.15,67.05 61.18,67.05 29.76,0 56.69,-19.39 67.8,-46.23 v 0 c 2.71,-6.55 4.48,-13.55 5.12,-20.82 3.23,-37.03 -24.16,-67.05 -61.19,-67.05 m -24.53,88.34 c -9.36,0 -14.99,-6.17 -14.19,-15.43 0.48,-5.42 3.46,-11.48 9.58,-17.01 l 26.36,-24.15 22.15,24.15 c 5.16,5.53 7.07,11.59 6.59,17.01 -0.8,9.26 -7.51,15.43 -16.87,15.43 -8.73,0 -11.35,-4.04 -15.95,-9.89 -5.62,5.85 -8.95,9.89 -17.67,9.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2603.6,1827.84 -26.36,24.15 c -6.12,5.53 -9.1,11.59 -9.58,17.01 -0.8,9.26 4.83,15.43 14.19,15.43 8.72,0 12.05,-4.04 17.67,-9.89 4.6,5.85 7.22,9.89 15.95,9.89 9.36,0 16.07,-6.17 16.87,-15.43 0.48,-5.42 -1.43,-11.48 -6.59,-17.01 l -22.15,-24.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2637.53,2193.02 c -22.4,0 -43.19,10.98 -56.84,27.85 -7.01,8.66 -12.13,18.87 -14.63,29.95 l 22.22,64.08 c 2.8,2.1 5.8,3.97 8.97,5.57 v 0 c 8.44,4.26 18.11,6.64 28.55,6.64 37.03,0 69.67,-30.02 72.91,-67.04 1.09,-12.5 -1.3,-24.2 -6.38,-34.21 -9.96,-19.66 -30.27,-32.84 -54.8,-32.84 m -48.26,70.83 c 0,-1.25 0.05,-2.51 0.17,-3.78 2.04,-23.33 22.6,-42.24 45.92,-42.24 22.05,0 38.67,16.9 38.7,38.45 0,1.25 -0.05,2.51 -0.16,3.79 -2.04,23.32 -22.6,42.23 -45.93,42.23 -22.05,0 -38.67,-16.9 -38.7,-38.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    style: {
      fill: "#d3e0f4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2635.36,2217.83 c -23.32,0 -43.88,18.91 -45.92,42.24 -0.12,1.27 -0.17,2.53 -0.17,3.78 0.03,21.55 16.65,38.45 38.7,38.45 23.33,0 43.89,-18.91 45.93,-42.23 0.11,-1.28 0.16,-2.54 0.16,-3.79 -0.03,-21.55 -16.65,-38.45 -38.7,-38.45 m -2.37,27.11 c 5.19,0 10.56,-1.98 15.21,-5.95 0.81,-0.7 1.68,-1 2.5,-1 2.87,0 5.08,3.66 2.18,6.13 -6.24,5.33 -13.5,7.99 -20.52,7.99 -7.02,0 -13.81,-2.66 -19.12,-7.99 -2.46,-2.47 0.39,-6.13 3.26,-6.13 0.81,0 1.63,0.3 2.33,1 3.94,3.96 8.97,5.95 14.16,5.95 m 10.41,37.2 c -1.97,0 -3.25,-3.73 -2.85,-8.32 0.4,-4.59 2.33,-8.32 4.31,-8.32 1.98,0 3.26,3.73 2.85,8.32 -0.4,4.59 -2.33,8.32 -4.31,8.32 m -27.33,0 c -1.98,0 -3.26,-3.73 -2.86,-8.32 0.4,-4.59 2.33,-8.32 4.31,-8.32 1.98,0 3.25,3.73 2.85,8.32 -0.4,4.59 -2.33,8.32 -4.3,8.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2650.7,2237.99 c -0.82,0 -1.69,0.3 -2.5,1 -4.65,3.97 -10.02,5.95 -15.21,5.95 -5.19,0 -10.22,-1.99 -14.16,-5.95 -0.7,-0.7 -1.52,-1 -2.33,-1 -2.87,0 -5.72,3.66 -3.26,6.13 5.31,5.33 12.1,7.99 19.12,7.99 7.02,0 14.28,-2.66 20.52,-7.99 2.9,-2.47 0.69,-6.13 -2.18,-6.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2617.52,2265.5 c -1.98,0 -3.91,3.73 -4.31,8.32 -0.4,4.59 0.88,8.32 2.86,8.32 1.97,0 3.9,-3.73 4.3,-8.32 0.4,-4.59 -0.87,-8.32 -2.85,-8.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2644.86,2265.5 c -1.98,0 -3.91,3.73 -4.31,8.32 -0.4,4.59 0.88,8.32 2.85,8.32 1.98,0 3.91,-3.73 4.31,-8.32 0.41,-4.59 -0.87,-8.32 -2.85,-8.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    style: {
      fill: "#b4caec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1824.58,2470.31 -154.51,13.41 v 0 l 154.51,-13.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    style: {
      fill: "#f3f8fd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1700.7,1799.88 -259.89,22.57 16.23,46.81 225.51,-19.58 c 1.19,-0.11 2.36,-0.16 3.51,-0.16 20.3,0 34.84,15.64 33.03,36.39 l -6.61,75.59 c -0.44,4.96 -1.77,9.8 -3.83,14.32 l 11,-0.87 c 0.41,-0.03 0.82,-0.05 1.23,-0.05 7.81,0 13.38,6.07 12.59,14.06 l -4.99,50.78 22.62,-1.96 c 1.18,-0.11 2.35,-0.16 3.51,-0.16 20.29,0 34.84,15.64 33.02,36.39 l -6.61,75.59 c -0.99,11.35 -6.69,22 -15.02,29.91 l 2.78,5.1 17.65,-1.4 c 0.41,-0.03 0.82,-0.05 1.22,-0.05 7.82,0 13.39,6.07 12.6,14.06 l -5,50.92 c -0.83,8.38 -8.33,15.7 -16.76,16.34 l -61.33,4.67 c -0.4,0.03 -0.79,0.04 -1.17,0.04 -7.82,0 -13.39,-6.07 -12.6,-14.06 l 5.02,-51.02 c 0.32,-3.33 1.7,-6.49 3.78,-9.13 l -138.07,11.98 9.39,27.09 24.21,-2.1 c 1.19,-0.11 2.37,-0.16 3.52,-0.16 20.29,0 34.83,15.64 33.02,36.39 l -6.61,75.59 c -0.7,8 -3.74,15.65 -8.39,22.24 l 4.21,12.13 9.58,-0.76 c 0.42,-0.03 0.83,-0.05 1.23,-0.05 7.82,0 13.38,6.07 12.6,14.06 l -4.16,42.29 17.35,50.04 154.51,-13.41 62.51,-5.43 8.9,-101.72 -195.29,-563.28 m -60.18,207.27 -131.71,11.43 13.54,39.06 114.2,-9.92 c 0.01,-0.28 0.03,-0.56 0.06,-0.85 l 3.91,-39.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1611.24,2231.79 c -1.15,0 -2.33,0.05 -3.52,0.16 l -24.21,2.1 45.75,131.96 c 4.65,-6.59 7.69,-14.24 8.39,-22.24 l 6.61,-75.59 c 1.81,-20.75 -12.73,-36.39 -33.02,-36.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1644.28,2377.33 c -0.4,0 -0.81,0.02 -1.23,0.05 l -9.58,0.76 19.25,55.54 4.16,-42.29 c 0.78,-7.99 -4.78,-14.06 -12.6,-14.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1754.61,2037.62 c -1.16,0 -2.33,0.05 -3.51,0.16 l -22.62,1.96 -0.02,0.14 c -0.82,8.38 -8.32,15.69 -16.75,16.34 l -61.33,4.67 c -0.4,0.03 -0.79,0.04 -1.18,0.04 -7.54,0 -12.97,-5.64 -12.65,-13.21 l -114.2,9.92 10.02,28.9 36.95,-3.21 c 0.31,-0.02 0.61,-0.04 0.91,-0.04 4.98,0 8.63,3.63 8.62,8.58 -0.01,0.29 -0.02,0.58 -0.04,0.87 -0.5,5.7 -5.56,10.72 -11.3,11.22 l -28.25,2.45 5.53,15.96 105.67,-9.18 c 0.3,-0.03 0.61,-0.04 0.91,-0.04 4.98,0 8.63,3.63 8.61,8.58 0,0.29 -0.01,0.58 -0.04,0.88 -0.49,5.69 -5.55,10.71 -11.29,11.21 l -96.97,8.42 5.53,15.95 138.8,-12.04 c 0.31,-0.03 0.61,-0.05 0.91,-0.05 4.99,0 8.63,3.63 8.62,8.58 0,0.29 -0.01,0.58 -0.04,0.87 -0.5,5.7 -5.56,10.72 -11.29,11.22 l -130.11,11.3 10.02,28.89 138.07,-11.98 c 3.14,-3.99 7.86,-6.8 12.92,-7.2 l 17.75,-1.41 8.7,-12.45 c 1.59,-2.26 4.02,-3.43 6.27,-3.43 1.94,0 3.73,0.87 4.71,2.66 l 3.46,6.36 c 8.33,-7.91 14.03,-18.56 15.02,-29.91 l 6.61,-75.59 c 1.82,-20.75 -12.73,-36.39 -33.02,-36.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    style: {
      fill: "#cacdcd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1696.92,2146.1 c -0.3,0 -0.6,0.02 -0.91,0.05 l -138.8,12.04 6.89,19.88 130.11,-11.3 c 5.73,-0.5 10.79,-5.52 11.29,-11.22 0.03,-0.29 0.04,-0.58 0.04,-0.87 0.01,-4.95 -3.63,-8.58 -8.62,-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    style: {
      fill: "#cacdcd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1570.23,2083.29 c -0.3,0 -0.6,0.02 -0.91,0.04 l -36.95,3.21 6.89,19.87 28.25,-2.45 c 5.74,-0.5 10.8,-5.52 11.3,-11.22 0.02,-0.29 0.03,-0.58 0.04,-0.87 0.01,-4.95 -3.64,-8.58 -8.62,-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    style: {
      fill: "#cacdcd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1651.37,2113.15 c -0.3,0 -0.61,0.01 -0.91,0.04 l -105.67,9.18 6.89,19.87 96.97,-8.42 c 5.74,-0.5 10.8,-5.52 11.29,-11.21 0.03,-0.3 0.04,-0.59 0.04,-0.88 0.02,-4.95 -3.63,-8.58 -8.61,-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1757.83,2170.49 c -2.25,0 -4.68,1.17 -6.27,3.43 l -8.7,12.45 -17.75,1.41 c -5.06,0.4 -9.78,3.21 -12.92,7.2 -2.08,2.64 -3.46,5.8 -3.78,9.13 l -5.02,51.02 c -0.79,7.99 4.78,14.06 12.6,14.06 0.38,0 0.77,-0.01 1.17,-0.04 l 61.33,-4.67 c 8.43,-0.64 15.93,-7.96 16.76,-16.34 l 5,-50.92 c 0.79,-7.99 -4.78,-14.06 -12.6,-14.06 -0.4,0 -0.81,0.02 -1.22,0.05 l -17.65,1.4 -2.78,-5.1 -3.46,-6.36 c -0.98,-1.79 -2.77,-2.66 -4.71,-2.66 m -24.04,79.85 c -7.16,0 -11.37,-4.7 -10.73,-12.12 0.41,-4.65 2.98,-10.02 8.26,-15.19 l 22.74,-22.5 19.13,18.87 c 4.45,4.31 6.11,9.33 5.71,13.97 -0.7,7.93 -6.49,13.68 -14.57,14.38 -0.65,0.06 -1.26,0.09 -1.84,0.09 -6.09,0 -8.3,-3.07 -11.93,-7.31 -4.84,5.4 -7.72,9.09 -15.25,9.74 -0.52,0.05 -1.03,0.07 -1.52,0.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    style: {
      fill: "#f8fbfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1754.06,2200.53 -22.74,22.5 c -5.28,5.17 -7.85,10.54 -8.26,15.19 -0.64,7.42 3.57,12.12 10.73,12.12 0.49,0 1,-0.02 1.52,-0.07 7.53,-0.65 10.41,-4.34 15.25,-9.74 3.63,4.24 5.84,7.31 11.93,7.31 0.58,0 1.19,-0.03 1.84,-0.09 8.08,-0.7 13.87,-6.45 14.57,-14.38 0.4,-4.64 -1.26,-9.66 -5.71,-13.97 l -19.13,-18.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1686.06,1849.52 c -1.15,0 -2.32,0.05 -3.51,0.16 l -225.51,19.58 10.02,28.9 104.25,-9.05 c 0.31,-0.03 0.61,-0.04 0.91,-0.04 4.98,0 8.63,3.63 8.62,8.57 0,0.29 -0.02,0.58 -0.04,0.87 -0.5,5.71 -5.55,10.73 -11.3,11.22 l -95.55,8.3 5.53,15.96 62.13,-5.4 c 0.31,-0.03 0.61,-0.04 0.91,-0.04 4.98,0 8.63,3.63 8.62,8.58 -0.01,0.29 -0.02,0.58 -0.04,0.87 -0.5,5.69 -5.56,10.72 -11.3,11.22 l -53.43,4.64 5.53,15.95 135.57,-11.77 c 0.31,-0.03 0.61,-0.04 0.91,-0.04 4.98,0 8.63,3.63 8.61,8.58 0,0.28 -0.01,0.57 -0.04,0.87 -0.49,5.7 -5.55,10.72 -11.29,11.22 l -126.87,11.01 10.02,28.9 131.71,-11.43 1.11,-11.3 c 0.82,-8.36 8.29,-15.66 16.7,-16.33 l 17.75,-1.41 8.7,-12.45 c 1.59,-2.26 4.03,-3.43 6.27,-3.43 1.94,0 3.73,0.87 4.71,2.66 l 6.24,11.46 6.65,-0.53 c 2.06,-4.52 3.39,-9.36 3.83,-14.32 l 6.61,-75.59 c 1.81,-20.75 -12.73,-36.39 -33.03,-36.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path420",
    style: {
      fill: "#cacdcd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1628.38,1958 c -0.3,0 -0.6,0.01 -0.91,0.04 l -135.57,11.77 6.89,19.87 126.87,-11.01 c 5.74,-0.5 10.8,-5.52 11.29,-11.22 0.03,-0.3 0.04,-0.59 0.04,-0.87 0.02,-4.95 -3.63,-8.58 -8.61,-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    style: {
      fill: "#cacdcd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1572.22,1889.07 c -0.3,0 -0.6,0.01 -0.91,0.04 l -104.25,9.05 6.89,19.87 95.55,-8.3 c 5.75,-0.49 10.8,-5.51 11.3,-11.22 0.02,-0.29 0.04,-0.58 0.04,-0.87 0.01,-4.94 -3.64,-8.57 -8.62,-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    style: {
      fill: "#cacdcd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1542.52,1928.55 c -0.3,0 -0.6,0.01 -0.91,0.04 l -62.13,5.4 6.89,19.87 53.43,-4.64 c 5.74,-0.5 10.8,-5.53 11.3,-11.22 0.02,-0.29 0.03,-0.58 0.04,-0.87 0.01,-4.95 -3.64,-8.58 -8.62,-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path426",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1691.05,1962.23 c -2.24,0 -4.68,1.17 -6.27,3.43 l -8.7,12.45 -17.75,1.41 c -8.41,0.67 -15.88,7.97 -16.7,16.33 l -1.11,11.3 -3.91,39.72 c -0.03,0.29 -0.05,0.57 -0.06,0.85 -0.32,7.57 5.11,13.21 12.65,13.21 0.39,0 0.78,-0.01 1.18,-0.04 l 61.33,-4.67 c 8.43,-0.65 15.93,-7.96 16.75,-16.34 l 0.02,-0.14 4.99,-50.78 c 0.79,-7.99 -4.78,-14.06 -12.59,-14.06 -0.41,0 -0.82,0.02 -1.23,0.05 l -11,0.87 -6.65,0.53 -6.24,-11.46 c -0.98,-1.79 -2.77,-2.66 -4.71,-2.66 m -3.13,84.63 c -2.05,0 -3.92,-1.31 -3.91,-3.69 0.02,-8.81 -7.55,-15.68 -10.57,-18.07 -0.79,-0.62 -1.16,-1.61 -1.07,-2.71 l 1.71,-19.6 c 0.17,-1.82 1.63,-3.49 3.47,-3.93 l 22.14,-5.33 c 0.65,-0.15 1.29,-0.23 1.91,-0.23 3.11,0 5.66,1.92 6.3,4.96 l 3.4,16.38 c 0.35,1.68 0.07,3.53 -0.8,5.24 -1.48,2.92 -4.43,4.98 -7.53,5.25 l -11.57,1.01 c 3.03,9.49 2.64,14.92 0.97,18.01 -1,1.85 -2.79,2.71 -4.45,2.71 m -25.68,-21.67 c -2.3,0 -3.95,-1.77 -3.75,-4.12 l 1.5,-17.18 c 0.22,-2.48 2.43,-4.67 4.93,-4.89 0.14,-0.01 0.27,-0.02 0.4,-0.02 2.3,0 3.95,1.77 3.74,4.13 l -1.5,17.17 c -0.21,2.48 -2.42,4.67 -4.93,4.89 -0.13,0.01 -0.26,0.02 -0.39,0.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path428",
    style: {
      fill: "#f8fbfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1665.32,1998.98 c -0.13,0 -0.26,0.01 -0.4,0.02 -2.5,0.22 -4.71,2.41 -4.93,4.89 l -1.5,17.18 c -0.2,2.35 1.45,4.12 3.75,4.12 0.13,0 0.26,-0.01 0.39,-0.02 2.51,-0.22 4.72,-2.41 4.93,-4.89 l 1.5,-17.17 c 0.21,-2.36 -1.44,-4.13 -3.74,-4.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path430",
    style: {
      fill: "#f8fbfe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1701.6,1993.3 c -0.62,0 -1.26,0.08 -1.91,0.23 l -22.14,5.33 c -1.84,0.44 -3.3,2.11 -3.47,3.93 l -1.71,19.6 c -0.09,1.1 0.28,2.09 1.07,2.71 3.02,2.39 10.59,9.26 10.57,18.07 -0.01,2.38 1.86,3.69 3.91,3.69 1.66,0 3.45,-0.86 4.45,-2.71 1.67,-3.09 2.06,-8.52 -0.97,-18.01 l 11.57,-1.01 c 3.1,-0.27 6.05,-2.33 7.53,-5.25 0.87,-1.71 1.15,-3.56 0.8,-5.24 l -3.4,-16.38 c -0.64,-3.04 -3.19,-4.96 -6.3,-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path432",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3477.75,1365.3 H 1519.64 c -9.52,0 -17.23,7.71 -17.23,17.23 v 42.52 h 1992.56 v -42.52 c 0,-9.52 -7.71,-17.23 -17.22,-17.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path434",
    style: {
      fill: "#395eb4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3477.75,1365.3 H 2404.41 v 48.59 h 1090.56 v -31.36 c 0,-9.52 -7.71,-17.23 -17.22,-17.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path436",
    style: {
      fill: "#6b8ed1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2404.41,1365.3 h -884.77 c -9.52,0 -17.23,7.71 -17.23,17.23 v 31.36 h 902 v -48.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path438",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3535.55,1413.89 H 1461.83 c -11.22,0 -20.32,9.11 -20.32,20.33 v 9.35 c 0,11.22 9.1,20.32 20.32,20.32 h 2073.72 c 11.22,0 20.32,-9.1 20.32,-20.32 v -9.35 c 0,-11.22 -9.1,-20.33 -20.32,-20.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path440",
    style: {
      fill: "#8daee0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2404.41,1413.89 v 0 h -942.58 c -11.22,0 -20.32,9.11 -20.32,20.33 v 9.35 c 0,11.22 9.1,20.32 20.32,20.32 h 942.58 v -50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path442",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1607.6,1325.17 c -19.4,0 -35.19,-15.78 -35.19,-35.18 V 238.262 c 0,-19.403 15.79,-35.203 35.19,-35.203 h 691.62 c 19.41,0 35.19,15.8 35.19,35.203 V 1289.99 c 0,19.4 -15.78,35.18 -35.19,35.18 H 1607.6 M 2299.22,163.059 H 1607.6 c -41.46,0 -75.19,33.73 -75.19,75.203 V 1289.99 c 0,41.45 33.73,75.18 75.19,75.18 h 691.62 c 41.46,0 75.19,-33.73 75.19,-75.18 V 238.262 c 0,-41.473 -33.73,-75.203 -75.19,-75.203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path444",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2299.22,163.059 h -141.78 c 20.89,6.589 38.26,21.101 48.59,40 h 93.19 c 19.41,0 35.19,15.8 35.19,35.203 v 1051.728 0 c 0,2.61 -0.28,5.15 -0.83,7.6 h 40.45 c -3.62,35.82 -32.49,64.31 -68.49,67.32 38.51,-3.22 68.87,-35.6 68.87,-74.92 v -876.83 -2.5 -172.398 c 0,-41.473 -33.73,-75.203 -75.19,-75.203 m -726.81,955.001 h -40 v 171.93 c 0,34.84 23.84,64.23 56.06,72.72 -29.85,-7.86 -52.5,-33.66 -55.67,-65.12 h 40.44 c -0.54,-2.45 -0.83,-4.99 -0.83,-7.6 v -171.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path446",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1606.42,1325.15 c 0.01,0 0.01,0 0.01,0 0,0 0,0 -0.01,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path448",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1606.62,1325.16 h 0.01 -0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path450",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2300.2,1325.16 h -0.01 0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path452",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1607.01,1325.17 h 0.01 -0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path454",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2299.81,1325.17 c 0,0 0,0 -0.01,0 h 0.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path456",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1607.19,1325.17 c 0.02,0 0.03,0 0.04,0 -0.01,0 -0.02,0 -0.04,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path458",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2299.62,1325.17 c -0.01,0 -0.02,0 -0.03,0 0.01,0 0.02,0 0.03,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path460",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1607.4,1325.17 c 0.01,0 0.02,0 0.03,0 -0.01,0 -0.02,0 -0.03,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path462",
    style: {
      fill: "#2c3a42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2299.42,1325.17 c -0.01,0 -0.02,0 -0.03,0 0.01,0 0.02,0 0.03,0 m -710.95,37.54 c 0.07,0.02 0.14,0.03 0.21,0.05 -0.07,-0.02 -0.14,-0.03 -0.21,-0.05 m 0.21,0.05 c 0.07,0.02 0.14,0.04 0.21,0.06 -0.07,-0.02 -0.14,-0.04 -0.21,-0.06 m 0.21,0.06 c 0.56,0.14 1.12,0.28 1.69,0.41 -0.57,-0.13 -1.13,-0.27 -1.69,-0.41 m 1.71,0.41 c 0.06,0.02 0.12,0.03 0.19,0.05 -0.07,-0.02 -0.13,-0.03 -0.19,-0.05 m 0.21,0.05 c 0.06,0.02 0.12,0.03 0.18,0.04 -0.06,-0.01 -0.12,-0.02 -0.18,-0.04 m 0.22,0.05 c 0.06,0.02 0.12,0.03 0.17,0.04 -0.05,-0.01 -0.11,-0.02 -0.17,-0.04 m 0.22,0.05 c 0.05,0.01 0.11,0.03 0.17,0.04 -0.06,-0.01 -0.11,-0.03 -0.17,-0.04 m 0.22,0.05 c 0.06,0.01 0.11,0.02 0.17,0.04 -0.06,-0.02 -0.11,-0.03 -0.17,-0.04 m 0.22,0.05 c 0.05,0.01 0.11,0.02 0.16,0.03 -0.05,-0.01 -0.11,-0.02 -0.16,-0.03 m 0.22,0.05 c 0.05,0.01 0.11,0.02 0.16,0.03 -0.05,-0.01 -0.11,-0.02 -0.16,-0.03 m 0.22,0.04 c 0.05,0.01 0.1,0.02 0.15,0.03 -0.05,-0.01 -0.1,-0.02 -0.15,-0.03 m 0.23,0.05 c 0.05,0.01 0.1,0.02 0.15,0.03 -0.05,-0.01 -0.1,-0.02 -0.15,-0.03 m 0.2,0.04 c 0.06,0.01 0.11,0.02 0.17,0.04 -0.06,-0.02 -0.11,-0.03 -0.17,-0.04 m 0.19,0.04 c 0.35,0.07 0.69,0.14 1.04,0.2 -0.34,-0.06 -0.69,-0.13 -1.04,-0.2 m 1.07,0.21 c 0.05,0.01 0.11,0.02 0.16,0.03 -0.05,-0.01 -0.11,-0.02 -0.16,-0.03 m 0.22,0.04 c 0.05,0.01 0.1,0.02 0.15,0.03 -0.05,-0.01 -0.1,-0.02 -0.15,-0.03 m 0.23,0.04 c 0.04,0.01 0.09,0.02 0.14,0.02 -0.05,-0.01 -0.1,-0.01 -0.14,-0.02 m 0.22,0.04 c 0.05,0.01 0.09,0.01 0.14,0.02 -0.05,-0.01 -0.09,-0.01 -0.14,-0.02 m 0.22,0.04 c 0.05,0.01 0.1,0.01 0.14,0.02 -0.04,-0.01 -0.09,-0.01 -0.14,-0.02 m 0.22,0.04 c 0.05,0 0.1,0.01 0.15,0.02 -0.05,-0.01 -0.1,-0.02 -0.15,-0.02 m 0.23,0.03 c 0.04,0.01 0.09,0.02 0.14,0.03 -0.05,-0.01 -0.1,-0.02 -0.14,-0.03 m 0.23,0.04 c 0.04,0.01 0.08,0.02 0.13,0.02 -0.05,0 -0.09,-0.01 -0.13,-0.02 m 0.22,0.04 c 0.05,0 0.09,0.01 0.13,0.02 -0.04,-0.01 -0.08,-0.02 -0.13,-0.02 m 0.23,0.03 c 0.04,0.01 0.08,0.02 0.13,0.02 -0.04,0 -0.09,-0.01 -0.13,-0.02 m 0.23,0.04 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.23,0.03 c 0.04,0.01 0.08,0.02 0.12,0.02 -0.04,0 -0.08,-0.01 -0.12,-0.02 m 0.2,0.03 c 0.17,0.03 0.34,0.05 0.51,0.08 -0.17,-0.03 -0.34,-0.05 -0.51,-0.08 m 0.59,0.09 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.22,0.03 c 0.05,0.01 0.09,0.01 0.13,0.02 -0.04,-0.01 -0.08,-0.01 -0.13,-0.02 m 0.23,0.03 c 0.04,0.01 0.09,0.01 0.13,0.02 -0.04,-0.01 -0.09,-0.01 -0.13,-0.02 m 0.23,0.03 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.23,0.03 c 0.04,0.01 0.08,0.01 0.11,0.02 -0.03,-0.01 -0.07,-0.01 -0.11,-0.02 m 0.22,0.03 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.23,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.23,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.11,0.02 -0.03,-0.01 -0.07,-0.01 -0.11,-0.02 m 0.23,0.03 c 0.04,0 0.08,0.01 0.11,0.01 -0.03,0 -0.07,-0.01 -0.11,-0.01 m 0.25,0.03 c 0.03,0 0.06,0 0.09,0.01 -0.03,-0.01 -0.06,-0.01 -0.09,-0.01 m 0.23,0.02 c 0.03,0 0.06,0.01 0.09,0.01 -0.03,0 -0.06,-0.01 -0.09,-0.01 m 0.22,0.02 c 0.07,0.01 0.14,0.01 0.22,0.02 -0.08,-0.01 -0.15,-0.01 -0.22,-0.02 m 0.33,0.03 c 0.03,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.08,0 -0.11,-0.01 m 0.23,0.02 c 0.03,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.08,0 -0.11,-0.01 m 0.23,0.02 c 0.04,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.07,0 -0.11,-0.01 m 704.44,0.02 c -0.07,0.01 -0.13,0.01 -0.2,0.02 0.07,-0.01 0.14,-0.01 0.2,-0.02 m -704.21,0 c 0.04,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.07,0 -0.11,-0.01 m 703.98,0.02 c -0.06,0 -0.12,0.01 -0.18,0.01 0.06,0 0.12,-0.01 0.18,-0.01 m -703.75,0 c 0.04,0 0.07,0.01 0.11,0.01 -0.04,0 -0.07,-0.01 -0.11,-0.01 m 703.51,0.02 c -0.05,0 -0.11,0.01 -0.16,0.01 0.05,0 0.11,-0.01 0.16,-0.01 m -703.28,0 c 0.04,0 0.07,0.01 0.11,0.01 -0.04,0 -0.07,-0.01 -0.11,-0.01 m 703.06,0.02 c -0.06,0 -0.12,0 -0.17,0.01 0.05,-0.01 0.11,-0.01 0.17,-0.01 m -702.83,0 c 0.04,0 0.08,0 0.12,0.01 -0.04,-0.01 -0.08,-0.01 -0.12,-0.01 m 702.6,0.01 c -0.06,0.01 -0.11,0.01 -0.17,0.01 0.06,0 0.11,0 0.17,-0.01 m -702.37,0 c 0.04,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.08,0 -0.12,-0.01 m 702.14,0.02 c -0.06,0 -0.11,0 -0.17,0.01 0.06,0 0.11,-0.01 0.17,-0.01 m -701.9,0 c 0.03,0 0.07,0 0.11,0.01 -0.04,-0.01 -0.08,-0.01 -0.11,-0.01 m 701.66,0.01 c -0.05,0.01 -0.1,0.01 -0.15,0.01 0.05,0 0.1,0 0.15,-0.01 m -701.43,0.01 c 0.04,0 0.07,0 0.11,0 -0.04,0 -0.07,0 -0.11,0 m 701.21,0.01 c -0.06,0 -0.11,0 -0.17,0.01 0.06,-0.01 0.11,-0.01 0.17,-0.01 m -700.98,0 c 0.04,0 0.08,0 0.11,0.01 -0.03,-0.01 -0.07,-0.01 -0.11,-0.01 m 700.76,0.01 c -0.06,0 -0.12,0.01 -0.17,0.01 0.05,0 0.11,-0.01 0.17,-0.01 m -700.52,0 c 0.03,0.01 0.07,0.01 0.1,0.01 -0.03,0 -0.07,0 -0.1,-0.01 m 700.28,0.01 c -0.06,0.01 -0.11,0.01 -0.17,0.01 0.06,0 0.12,0 0.17,-0.01 m -700.04,0.01 c 0.03,0 0.06,0 0.1,0 -0.04,0 -0.07,0 -0.1,0 m 699.84,0.01 c -0.2,0.01 -0.4,0.02 -0.6,0.03 0.2,-0.01 0.4,-0.02 0.6,-0.03 m -699.58,0 c 0.02,0 0.04,0 0.07,0.01 -0.03,-0.01 -0.05,-0.01 -0.07,-0.01 m 0.25,0.01 c 0.04,0.01 0.09,0.01 0.13,0.01 -0.04,0 -0.09,0 -0.13,-0.01 m 698.68,0.02 c -0.04,0 -0.09,0 -0.14,0 0.05,0 0.1,0 0.14,0 m -698.4,0 c 0.03,0 0.06,0 0.09,0 -0.03,0 -0.06,0 -0.09,0 m 698.17,0.01 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -697.93,0 c 0.03,0 0.06,0 0.09,0 -0.03,0 -0.06,0 -0.09,0 m 697.69,0.01 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -697.46,0 c 0.03,0 0.07,0 0.1,0 -0.03,0 -0.07,0 -0.1,0 m 697.23,0.01 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -697,0 c 0.04,0 0.07,0 0.11,0 -0.04,0 -0.07,0 -0.11,0 m 696.77,0 c -0.04,0 -0.08,0.01 -0.12,0.01 0.04,0 0.08,-0.01 0.12,-0.01 m -696.53,0 c 0.03,0 0.07,0.01 0.1,0.01 -0.03,0 -0.07,-0.01 -0.1,-0.01 m 696.29,0.01 c -0.04,0 -0.07,0 -0.11,0 0.04,0 0.07,0 0.11,0 m -696.06,0 c 0.04,0 0.07,0 0.11,0 -0.04,0 -0.07,0 -0.11,0 m 695.83,0.01 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -695.59,0 c 0.03,0 0.07,0 0.1,0 -0.03,0 -0.07,0 -0.1,0 m 695.35,0 c -0.04,0 -0.07,0 -0.11,0.01 0.04,-0.01 0.08,-0.01 0.11,-0.01 m -695.12,0 c 0.04,0 0.07,0 0.11,0.01 -0.04,-0.01 -0.08,-0.01 -0.11,-0.01 m 694.88,0.01 c -0.03,0 -0.07,0 -0.1,0 0.03,0 0.07,0 0.1,0 m -694.64,0 c 0.03,0 0.07,0 0.1,0 -0.03,0 -0.07,0 -0.1,0 m 694.4,0 c -0.03,0 -0.06,0 -0.1,0 0.04,0 0.07,0 0.1,0 m -694.16,0 c 0.03,0 0.06,0 0.09,0 -0.03,0 -0.06,0 -0.09,0 m 693.93,0.01 c -0.04,0 -0.07,0 -0.1,0 0.03,0 0.06,0 0.1,0 m -693.69,0 c 0.03,0 0.06,0 0.09,0 -0.03,0 -0.06,0 -0.09,0 m 693.45,0 c -0.03,0 -0.06,0 -0.1,0 0.04,0 0.07,0 0.1,0 m -693.22,0 c 0.03,0 0.07,0 0.1,0 -0.03,0 -0.07,0 -0.1,0 m 692.98,0 c -0.03,0 -0.06,0 -0.09,0 0.03,0 0.06,0 0.09,0 m -692.74,0 c 0.03,0 0.06,0 0.09,0 -0.03,0 -0.06,0 -0.09,0 m 692.49,0 c -0.02,0 -0.05,0 -0.08,0 0.03,0 0.06,0 0.08,0 m -692.24,0 c 0.02,0 0.05,0 0.08,0 -0.03,0 -0.05,0 -0.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path464",
    style: {
      fill: "#cecdcc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2333.58,1297.59 h -0.05 c -3.4,15.38 -16.87,27.03 -33.14,27.56 16.28,-0.53 29.79,-12.17 33.19,-27.56 m -760.29,0 h -0.05 c 3.4,15.39 16.91,27.02 33.18,27.56 -16.26,-0.53 -29.72,-12.18 -33.13,-27.56 m 727.1,27.56 c -0.06,0.01 -0.13,0.01 -0.19,0.01 0.06,0 0.13,0 0.19,-0.01 m -693.96,0 c 0.06,0.01 0.13,0.01 0.19,0.01 -0.06,0 -0.13,0 -0.19,-0.01 m 693.76,0.01 c -0.12,0 -0.25,0.01 -0.38,0.01 0.13,0 0.26,-0.01 0.38,-0.01 m -693.56,0 c 0.13,0 0.25,0.01 0.38,0.01 -0.13,0 -0.25,-0.01 -0.38,-0.01 m 693.17,0.01 c -0.06,0 -0.12,0 -0.18,0 0.06,0 0.12,0 0.18,0 m -692.78,0 c 0.06,0 0.12,0 0.17,0 -0.05,0 -0.11,0 -0.17,0 m 692.57,0 c -0.05,0 -0.11,0 -0.17,0 0.06,0 0.12,0 0.17,0 m -692.36,0 c 0.05,0 0.11,0 0.17,0 -0.06,0 -0.12,0 -0.17,0 m 692.16,0 c -0.06,0 -0.12,0 -0.17,0 H 1607.6 c -0.05,0 -0.11,0 -0.17,0 0.06,0 0.12,0 0.17,0 h 691.62 c 0.05,0 0.11,0 0.17,0 m -710.92,37.54 v 0 0 m 0.21,0.05 v 0 0 m 0.21,0.06 v 0 0 m 1.69,0.41 c 0,0 0.01,0 0.02,0 -0.01,0 -0.02,0 -0.02,0 m 0.21,0.05 c 0,0 0.01,0 0.02,0 -0.01,0 -0.02,0 -0.02,0 m 0.2,0.04 c 0.01,0.01 0.03,0.01 0.04,0.01 -0.01,0 -0.02,0 -0.04,-0.01 m 0.21,0.05 c 0.02,0 0.03,0.01 0.05,0.01 -0.01,0 -0.03,-0.01 -0.05,-0.01 m 0.22,0.05 c 0.01,0 0.03,0.01 0.05,0.01 -0.02,0 -0.03,-0.01 -0.05,-0.01 m 0.22,0.05 c 0.01,0 0.03,0 0.05,0.01 -0.02,-0.01 -0.04,-0.01 -0.05,-0.01 m 0.21,0.04 c 0.02,0.01 0.04,0.01 0.06,0.02 -0.02,-0.01 -0.04,-0.01 -0.06,-0.02 m 0.22,0.05 c 0.02,0 0.04,0.01 0.06,0.01 -0.02,0 -0.04,-0.01 -0.06,-0.01 m 0.21,0.04 c 0.03,0.01 0.05,0.01 0.08,0.02 -0.03,-0.01 -0.05,-0.01 -0.08,-0.02 m 0.23,0.05 c 0.01,0 0.03,0.01 0.05,0.01 -0.02,0 -0.04,-0.01 -0.05,-0.01 m 0.22,0.05 c 0.01,0 0.02,0 0.02,0 -0.01,0 -0.01,0 -0.02,0 m 1.06,0.2 c 0.01,0 0.02,0 0.03,0.01 -0.01,-0.01 -0.02,-0.01 -0.03,-0.01 m 0.19,0.04 c 0.02,0 0.04,0 0.06,0.01 -0.02,-0.01 -0.04,-0.01 -0.06,-0.01 m 0.21,0.04 c 0.03,0 0.05,0 0.08,0.01 -0.03,-0.01 -0.05,-0.01 -0.08,-0.01 m 0.22,0.03 c 0.02,0.01 0.05,0.01 0.08,0.02 -0.03,-0.01 -0.05,-0.01 -0.08,-0.02 m 0.22,0.04 c 0.03,0.01 0.06,0.01 0.08,0.02 -0.02,-0.01 -0.05,-0.01 -0.08,-0.02 m 0.22,0.04 c 0.03,0.01 0.06,0.01 0.08,0.02 -0.02,-0.01 -0.05,-0.01 -0.08,-0.02 m 0.23,0.04 c 0.02,0 0.05,0.01 0.08,0.01 -0.03,0 -0.06,-0.01 -0.08,-0.01 m 0.22,0.04 c 0.03,0 0.06,0.01 0.09,0.01 -0.03,0 -0.06,-0.01 -0.09,-0.01 m 0.22,0.03 c 0.03,0.01 0.07,0.01 0.09,0.02 -0.03,-0.01 -0.06,-0.01 -0.09,-0.02 m 0.22,0.04 c 0.03,0 0.07,0.01 0.1,0.01 -0.03,0 -0.07,-0.01 -0.1,-0.01 m 0.23,0.03 c 0.03,0.01 0.06,0.01 0.1,0.02 -0.03,-0.01 -0.07,-0.01 -0.1,-0.02 m 0.22,0.04 c 0.04,0 0.07,0.01 0.11,0.01 -0.04,0 -0.07,-0.01 -0.11,-0.01 m 0.23,0.03 c 0.02,0.01 0.05,0.01 0.08,0.01 -0.03,0 -0.05,0 -0.08,-0.01 m 0.59,0.09 c 0.03,0 0.05,0.01 0.08,0.01 -0.03,0 -0.05,-0.01 -0.08,-0.01 m 0.2,0.03 c 0.04,0 0.07,0.01 0.1,0.01 -0.03,0 -0.06,-0.01 -0.1,-0.01 m 0.23,0.03 c 0.03,0 0.07,0.01 0.1,0.01 -0.03,0 -0.07,-0.01 -0.1,-0.01 m 0.23,0.03 c 0.03,0 0.06,0.01 0.1,0.01 -0.04,0 -0.07,-0.01 -0.1,-0.01 m 0.22,0.03 c 0.04,0 0.07,0.01 0.11,0.01 -0.04,0 -0.07,-0.01 -0.11,-0.01 m 0.22,0.03 c 0.04,0 0.08,0.01 0.11,0.01 -0.03,0 -0.07,-0.01 -0.11,-0.01 m 0.23,0.03 c 0.04,0 0.08,0 0.11,0.01 -0.03,-0.01 -0.07,-0.01 -0.11,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.11,0.02 -0.04,-0.01 -0.07,-0.01 -0.11,-0.02 m 0.23,0.03 c 0.04,0 0.07,0.01 0.11,0.01 -0.04,0 -0.07,-0.01 -0.11,-0.01 m 0.23,0.03 c 0.03,0 0.07,0.01 0.11,0.01 -0.04,0 -0.08,-0.01 -0.11,-0.01 m 0.23,0.02 c 0.03,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.08,0 -0.11,-0.01 m 0.22,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.02 c 0.05,0.01 0.09,0.01 0.14,0.02 -0.05,-0.01 -0.09,-0.01 -0.14,-0.02 m 0.23,0.03 c 0.05,0 0.09,0 0.14,0.01 -0.05,-0.01 -0.09,-0.01 -0.14,-0.01 m 0.23,0.02 c 0.04,0 0.09,0.01 0.13,0.01 -0.04,0 -0.09,-0.01 -0.13,-0.01 m 0.35,0.03 c 0.03,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.08,-0.01 -0.11,-0.01 m 0.22,0.02 c 0.04,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.08,0 -0.12,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.08,0 -0.12,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.08,0 -0.12,-0.01 m 704.34,0.01 h -0.01 0.01 m -704.11,0.01 c 0.04,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.08,0 -0.12,-0.01 m 703.9,0.01 c -0.01,0 -0.02,0 -0.03,0 0.01,0 0.02,0 0.03,0 m -703.67,0.01 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 703.46,0 c -0.02,0 -0.04,0.01 -0.06,0.01 0.02,0 0.04,0 0.06,-0.01 m -703.23,0.02 c 0.04,0 0.08,0 0.12,0.01 -0.04,-0.01 -0.08,-0.01 -0.12,-0.01 m 703.01,0 c -0.02,0 -0.04,0 -0.06,0.01 0.02,-0.01 0.03,-0.01 0.06,-0.01 m -702.77,0.02 c 0.03,0 0.07,0 0.11,0 -0.04,0 -0.08,0 -0.11,0 m 702.54,0 c -0.02,0 -0.04,0 -0.06,0 0.02,0 0.04,0 0.06,0 m -702.31,0.01 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 702.08,0 c -0.02,0 -0.04,0.01 -0.06,0.01 0.02,0 0.04,-0.01 0.06,-0.01 m -701.85,0.02 c 0.04,0 0.08,0 0.12,0.01 -0.04,-0.01 -0.08,-0.01 -0.12,-0.01 m 701.62,0 c -0.02,0 -0.04,0 -0.07,0 0.03,0 0.05,0 0.07,0 m -701.39,0.01 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 701.17,0 c -0.03,0 -0.05,0.01 -0.07,0.01 0.02,0 0.04,-0.01 0.07,-0.01 m -700.94,0.02 c 0.05,0 0.08,0 0.13,0 -0.05,0 -0.08,0 -0.13,0 m 700.7,0 c -0.02,0 -0.03,0 -0.05,0 0.01,0 0.03,0 0.05,0 m -700.47,0.01 c 0.05,0 0.09,0.01 0.14,0.01 -0.05,0 -0.09,-0.01 -0.14,-0.01 m 700.25,0 c -0.03,0 -0.05,0 -0.07,0 0.02,0 0.04,0 0.07,0 m -700.01,0.01 c 0.05,0.01 0.1,0.01 0.16,0.01 -0.06,0 -0.11,0 -0.16,-0.01 m 699.77,0 c -0.01,0 -0.02,0 -0.03,0.01 0.01,-0.01 0.02,-0.01 0.03,-0.01 m -699.54,0.02 c 0.06,0 0.12,0 0.18,0 -0.06,0 -0.12,0 -0.18,0 m 0.31,0.01 c 0.05,0 0.1,0.01 0.15,0.01 -0.05,0 -0.1,-0.01 -0.15,-0.01 m 698.6,0.01 c -0.02,0 -0.03,0 -0.05,0 0.02,0 0.03,0 0.05,0 m -698.36,0 c 0.04,0 0.1,0.01 0.15,0.01 -0.05,0 -0.1,-0.01 -0.15,-0.01 m 698.17,0 c -0.03,0 -0.06,0.01 -0.09,0.01 0.03,0 0.06,-0.01 0.09,-0.01 m -697.93,0.01 c 0.05,0 0.09,0 0.14,0.01 -0.05,0 -0.09,-0.01 -0.14,-0.01 m 697.72,0 c -0.04,0 -0.08,0.01 -0.12,0.01 0.04,0 0.08,-0.01 0.12,-0.01 m -697.48,0.01 c 0.04,0 0.09,0 0.13,0.01 -0.04,-0.01 -0.09,-0.01 -0.13,-0.01 m 697.24,0 c -0.03,0 -0.07,0 -0.11,0.01 0.04,-0.01 0.07,-0.01 0.11,-0.01 m -697,0.01 c 0.04,0 0.08,0 0.13,0 -0.04,0 -0.09,0 -0.13,0 m 696.77,0 c -0.04,0 -0.07,0 -0.11,0 0.03,0 0.07,0 0.11,0 m -696.54,0.01 c 0.05,0 0.09,0 0.13,0 -0.04,0 -0.09,0 -0.13,0 m 696.31,0 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -696.07,0 c 0.04,0 0.09,0.01 0.13,0.01 -0.05,0 -0.09,-0.01 -0.13,-0.01 m 695.84,0 c -0.04,0 -0.08,0.01 -0.12,0.01 0.04,0 0.08,-0.01 0.12,-0.01 m -695.61,0.01 c 0.05,0 0.09,0 0.13,0 -0.04,0 -0.08,0 -0.13,0 m 695.37,0 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.09,0 0.12,0 m -695.13,0.01 c 0.04,0 0.08,0 0.13,0 -0.04,0 -0.09,0 -0.13,0 m 694.9,0 c -0.04,0 -0.08,0 -0.13,0 0.04,0 0.09,0 0.13,0 m -694.67,0 c 0.05,0 0.09,0 0.14,0 -0.05,0 -0.09,0 -0.14,0 m 694.44,0 c -0.04,0 -0.09,0 -0.14,0 0.05,0 0.09,0 0.14,0 m -694.21,0 c 0.05,0 0.1,0.01 0.15,0.01 -0.05,0 -0.1,-0.01 -0.15,-0.01 m 693.97,0 c -0.04,0 -0.09,0.01 -0.13,0.01 0.04,0 0.09,-0.01 0.13,-0.01 m -693.73,0.01 c 0.05,0 0.09,0 0.14,0 -0.05,0 -0.09,0 -0.14,0 m 693.5,0 c -0.05,0 -0.09,0 -0.14,0 0.05,0 0.09,0 0.14,0 m -693.26,0 c 0.05,0 0.1,0 0.14,0 -0.05,0 -0.09,0 -0.14,0 m 693.02,0 c -0.05,0 -0.09,0 -0.14,0 0.05,0 0.09,0 0.14,0 m -692.79,0 c 0.05,0 0.11,0 0.16,0 -0.05,0 -0.11,0 -0.16,0 m 692.56,0 c -0.05,0 -0.11,0 -0.16,0 0.05,0 0.11,0 0.16,0 m -692.32,0 c 0.08,0 0.16,0 0.23,0 -0.07,0 -0.15,0 -0.23,0 m 692.08,0 c -0.08,0 -0.16,0 -0.23,0 0.07,0 0.15,0 0.23,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path466",
    style: {
      fill: "#222d32",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2374.03,1297.59 h -40.45 c -3.4,15.39 -16.91,27.03 -33.19,27.56 v 0 c -0.06,0.01 -0.13,0.01 -0.19,0.01 h -0.01 c -0.12,0 -0.25,0.01 -0.38,0.01 h -0.01 c -0.06,0 -0.12,0 -0.18,0 -0.01,0 -0.02,0 -0.03,0 -0.05,0 -0.11,0 -0.17,0 -0.01,0 -0.02,0 -0.03,0 -0.06,0 -0.12,0 -0.17,0 H 1607.6 c -0.05,0 -0.11,0 -0.17,0 -0.01,0 -0.02,0 -0.03,0 -0.06,0 -0.12,0 -0.17,0 -0.01,0 -0.02,0 -0.04,0 -0.05,0 -0.11,0 -0.17,0 h -0.01 c -0.13,0 -0.25,-0.01 -0.38,-0.01 h -0.01 c -0.06,0 -0.13,0 -0.19,-0.01 0,0 0,0 -0.01,0 -16.27,-0.54 -29.78,-12.17 -33.18,-27.56 h -40.44 c 3.17,31.46 25.82,57.26 55.67,65.12 v 0 c 0.07,0.02 0.14,0.03 0.21,0.05 v 0 c 0.07,0.02 0.14,0.04 0.21,0.06 v 0 c 0.56,0.14 1.12,0.28 1.69,0.41 0,0 0.01,0 0.02,0 0.06,0.02 0.12,0.03 0.19,0.05 0,0 0.01,0 0.02,0 0.06,0.02 0.12,0.03 0.18,0.04 0.02,0.01 0.03,0.01 0.04,0.01 0.06,0.02 0.12,0.03 0.17,0.04 0.02,0 0.04,0.01 0.05,0.01 0.06,0.01 0.11,0.03 0.17,0.04 0.02,0 0.03,0.01 0.05,0.01 0.06,0.01 0.11,0.02 0.17,0.04 0.01,0 0.03,0 0.05,0.01 0.05,0.01 0.11,0.02 0.16,0.03 0.02,0.01 0.04,0.01 0.06,0.02 0.05,0.01 0.11,0.02 0.16,0.03 0.02,0 0.04,0.01 0.06,0.01 0.05,0.01 0.1,0.02 0.15,0.03 0.03,0.01 0.05,0.01 0.08,0.02 0.05,0.01 0.1,0.02 0.15,0.03 0.01,0 0.03,0.01 0.05,0.01 0.06,0.01 0.11,0.02 0.17,0.04 0.01,0 0.01,0 0.02,0 0.35,0.07 0.7,0.14 1.04,0.2 0.01,0 0.02,0 0.03,0.01 0.05,0.01 0.11,0.02 0.16,0.03 0.02,0 0.04,0 0.06,0.01 0.05,0.01 0.1,0.02 0.15,0.03 0.03,0 0.05,0 0.08,0.01 0.04,0.01 0.09,0.01 0.14,0.02 0.03,0.01 0.05,0.01 0.08,0.02 0.05,0.01 0.09,0.01 0.14,0.02 0.03,0.01 0.06,0.01 0.08,0.02 0.05,0.01 0.1,0.01 0.14,0.02 0.03,0.01 0.06,0.01 0.08,0.02 0.05,0 0.1,0.01 0.15,0.02 0.02,0 0.05,0.01 0.08,0.01 0.04,0.01 0.09,0.02 0.14,0.03 0.03,0 0.06,0.01 0.09,0.01 0.04,0.01 0.08,0.02 0.13,0.02 0.03,0.01 0.06,0.01 0.09,0.02 0.05,0 0.09,0.01 0.13,0.02 0.03,0 0.07,0.01 0.1,0.01 0.04,0.01 0.09,0.02 0.13,0.02 0.03,0.01 0.07,0.01 0.1,0.02 0.04,0.01 0.08,0.01 0.12,0.02 0.04,0 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.02 0.12,0.02 0.03,0.01 0.05,0.01 0.08,0.01 0.17,0.03 0.34,0.05 0.51,0.08 0.03,0 0.05,0.01 0.08,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.04,0 0.07,0.01 0.1,0.01 0.05,0.01 0.09,0.01 0.13,0.02 0.03,0 0.07,0.01 0.1,0.01 0.04,0.01 0.09,0.01 0.13,0.02 0.03,0 0.06,0.01 0.1,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.04,0 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.11,0.02 0.04,0 0.08,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.04,0 0.08,0 0.11,0.01 0.04,0 0.08,0.01 0.12,0.01 0.04,0.01 0.07,0.01 0.11,0.02 0.04,0 0.08,0.01 0.12,0.01 0.04,0 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.03,0 0.07,0.01 0.11,0.01 0.04,0 0.08,0.01 0.12,0.01 0.03,0.01 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.11,0.02 0.04,0 0.08,0.01 0.12,0.01 0.04,0 0.08,0.01 0.11,0.01 0.05,0.01 0.09,0.01 0.14,0.02 0.03,0 0.06,0 0.09,0.01 0.05,0 0.09,0 0.14,0.01 0.03,0 0.06,0.01 0.09,0.01 0.04,0 0.09,0.01 0.13,0.01 0.07,0.01 0.14,0.01 0.22,0.02 0.03,0 0.07,0.01 0.11,0.01 0.03,0.01 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.01 0.03,0.01 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.01 0.04,0.01 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.01 0.04,0.01 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.01 0.04,0 0.07,0.01 0.11,0.01 0.04,0 0.08,0.01 0.12,0.01 0.04,0 0.07,0.01 0.11,0.01 0.04,0 0.08,0 0.12,0.01 0.04,0 0.08,0 0.12,0.01 0.03,0 0.07,0 0.11,0 0.04,0.01 0.08,0.01 0.12,0.01 0.04,0 0.08,0.01 0.12,0.01 0.03,0 0.07,0 0.11,0.01 0.04,0 0.08,0 0.12,0.01 0.04,0 0.07,0 0.11,0 0.04,0 0.08,0.01 0.12,0.01 0.04,0 0.08,0 0.11,0.01 0.05,0 0.08,0 0.13,0 0.03,0.01 0.07,0.01 0.1,0.01 0.05,0 0.09,0.01 0.14,0.01 0.03,0 0.06,0 0.1,0 0.05,0.01 0.1,0.01 0.16,0.01 0.02,0 0.04,0 0.07,0.01 0.06,0 0.12,0 0.18,0 0.04,0.01 0.09,0.01 0.13,0.01 0.05,0 0.1,0.01 0.15,0.01 0.03,0 0.06,0 0.09,0 0.05,0 0.1,0.01 0.15,0.01 0.03,0 0.06,0 0.09,0 0.05,0 0.09,0.01 0.14,0.01 0.03,0 0.07,0 0.1,0 0.04,0 0.09,0 0.13,0.01 0.04,0 0.07,0 0.11,0 0.04,0 0.09,0 0.13,0 0.03,0 0.07,0.01 0.1,0.01 0.04,0 0.09,0 0.13,0 0.04,0 0.07,0 0.11,0 0.04,0 0.08,0.01 0.13,0.01 0.03,0 0.07,0 0.1,0 0.05,0 0.09,0 0.13,0 0.03,0 0.07,0 0.11,0.01 0.04,0 0.09,0 0.13,0 0.03,0 0.07,0 0.1,0 0.05,0 0.09,0 0.14,0 0.03,0 0.06,0 0.09,0 0.05,0 0.1,0.01 0.15,0.01 0.03,0 0.06,0 0.09,0 0.05,0 0.09,0 0.14,0 0.03,0 0.07,0 0.1,0 0.05,0 0.09,0 0.14,0 0.03,0 0.06,0 0.09,0 0.05,0 0.11,0 0.16,0 0.03,0 0.05,0 0.08,0 0.08,0 0.16,0 0.23,0 v 0 h 691.62 v 0 c 0.07,0 0.15,0 0.23,0 0.03,0 0.06,0 0.08,0 0.05,0 0.11,0 0.16,0 0.03,0 0.06,0 0.09,0 0.05,0 0.09,0 0.14,0 0.04,0 0.07,0 0.1,0 0.05,0 0.09,0 0.14,0 0.03,0 0.06,0 0.1,0 0.04,0 0.09,-0.01 0.13,-0.01 0.04,0 0.07,0 0.1,0 0.05,0 0.1,0 0.14,0 0.03,0 0.07,0 0.1,0 0.05,0 0.09,0 0.13,0 0.04,-0.01 0.07,-0.01 0.11,-0.01 0.04,0 0.08,0 0.12,0 0.04,0 0.08,0 0.12,0 0.04,0 0.08,-0.01 0.12,-0.01 0.04,0 0.07,0 0.11,0 0.04,0 0.08,0 0.12,0 0.04,0 0.08,-0.01 0.12,-0.01 0.04,0 0.07,0 0.11,0 0.04,0 0.08,0 0.12,0 0.04,-0.01 0.08,-0.01 0.11,-0.01 0.04,0 0.08,0 0.12,0 0.04,0 0.08,-0.01 0.12,-0.01 0.04,0 0.08,0 0.12,0 0.03,0 0.06,-0.01 0.09,-0.01 0.05,0 0.1,0 0.14,0 0.02,0 0.03,0 0.05,0 0.2,-0.01 0.4,-0.02 0.6,-0.03 0.01,-0.01 0.02,-0.01 0.03,-0.01 0.06,0 0.11,0 0.17,-0.01 0.02,0 0.04,0 0.07,0 0.05,0 0.11,-0.01 0.17,-0.01 0.02,0 0.03,0 0.05,0 0.06,-0.01 0.11,-0.01 0.17,-0.01 0.02,0 0.04,-0.01 0.07,-0.01 0.05,0 0.1,0 0.15,-0.01 0.03,0 0.05,0 0.07,0 0.06,-0.01 0.11,-0.01 0.17,-0.01 0.02,0 0.04,-0.01 0.06,-0.01 0.06,0 0.11,0 0.17,-0.01 0.02,0 0.04,0 0.06,0 0.05,-0.01 0.11,-0.01 0.17,-0.01 0.02,-0.01 0.04,-0.01 0.06,-0.01 0.05,0 0.11,-0.01 0.16,-0.01 0.02,0 0.04,-0.01 0.06,-0.01 0.06,0 0.12,-0.01 0.18,-0.01 0.01,0 0.02,0 0.03,0 0.07,-0.01 0.13,-0.01 0.2,-0.02 h 0.01 c 36,-3.01 64.87,-31.5 68.49,-67.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path468",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2684.16,1325.17 c -19.4,0 -35.19,-15.78 -35.19,-35.18 V 238.262 c 0,-19.403 15.79,-35.203 35.19,-35.203 h 691.61 c 19.41,0 35.2,15.8 35.2,35.203 V 1289.99 c 0,19.4 -15.79,35.18 -35.2,35.18 H 2684.16 M 3375.77,163.059 h -691.61 c -41.46,0 -75.19,33.73 -75.19,75.203 V 1289.99 c 0,41.45 33.73,75.18 75.19,75.18 h 691.61 c 41.47,0 75.2,-33.73 75.2,-75.18 V 238.262 c 0,-41.473 -33.73,-75.203 -75.2,-75.203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path470",
    style: {
      fill: "#304047",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3375.77,163.059 h -691.61 c -41.46,0 -75.19,33.73 -75.19,75.203 V 1289.99 c 0,34.54 23.41,63.71 55.21,72.49 -29.43,-8.13 -51.68,-33.74 -54.82,-64.89 h 40.44 c -0.54,-2.45 -0.83,-4.99 -0.83,-7.6 v -428.342 -2.5 -445.988 -2.5 -172.398 0 c 0,-19.403 15.79,-35.203 35.19,-35.203 h 691.61 c 19.41,0 35.2,15.8 35.2,35.203 v 21.226 l 17.88,3.571 -17.88,69.371 v 18.968 l 14.43,3.321 -12.5,50 -1.93,-0.41 v 373.25 c 12.72,-59.469 26.78,-120.418 40,-175.719 v -188.68 -2.5 -172.398 c 0,-2.551 -0.13,-5.071 -0.38,-7.551 -3.91,-1.199 -8.14,-2.371 -12.73,-3.52 -7.98,-2.043 -6.61,-16.863 3.6,-25.5 -12.86,-23.019 -37.49,-38.632 -65.69,-38.632 m 35.2,1005.071 v 77.43 c 13.68,0 26.98,0 40,0 v -67.09 c -12.73,-3.21 -26.12,-6.67 -40,-10.34 m 38.38,137.43 h -0.01 c -6.77,32.01 -33.96,56.56 -67.24,59.35 33.28,-2.79 60.48,-27.34 67.25,-59.35 m -766.37,19.59 h 0.01 -0.01 m 693.97,0 v 0 0 m -693.78,0.01 c 0.01,0 0.01,0 0.02,0 -0.01,0 -0.01,0 -0.02,0 m 693.59,0 c -0.01,0 -0.01,0 -0.01,0 h 0.01 m -693.2,0.01 c 0.01,0 0.01,0 0.02,0 -0.01,0 -0.01,0 -0.02,0 m 692.81,0 h -0.01 0.01 m -692.62,0 c 0.01,0 0.02,0 0.03,0 -0.01,0 -0.02,0 -0.03,0 m 692.43,0 c -0.01,0 -0.02,0 -0.03,0 0.01,0 0.02,0 0.03,0 m -692.23,0 c 0.01,0 0.02,0 0.03,0 -0.01,0 -0.02,0 -0.03,0 m 692.03,0 c -0.01,0 -0.02,0 -0.03,0 0.01,0 0.02,0 0.03,0 m -711.79,37.31 c 0.07,0.02 0.13,0.04 0.19,0.05 -0.06,-0.01 -0.12,-0.03 -0.19,-0.05 m 0.22,0.06 c 0.06,0.02 0.12,0.03 0.18,0.05 -0.06,-0.02 -0.12,-0.03 -0.18,-0.05 m 0.21,0.06 c 0.06,0.02 0.13,0.03 0.19,0.05 -0.06,-0.02 -0.13,-0.03 -0.19,-0.05 m 0.21,0.05 c 0.06,0.02 0.12,0.04 0.19,0.05 -0.07,-0.01 -0.13,-0.03 -0.19,-0.05 m 0.22,0.06 c 0.06,0.02 0.12,0.03 0.18,0.05 -0.06,-0.02 -0.12,-0.03 -0.18,-0.05 m 0.21,0.06 c 0.06,0.01 0.12,0.03 0.18,0.04 -0.06,-0.01 -0.12,-0.03 -0.18,-0.04 m 0.22,0.05 c 0.54,0.14 1.09,0.28 1.63,0.4 -0.55,-0.12 -1.09,-0.26 -1.63,-0.4 m 1.68,0.41 c 0.05,0.02 0.11,0.03 0.16,0.04 -0.05,-0.01 -0.11,-0.02 -0.16,-0.04 m 0.21,0.05 c 0.06,0.02 0.11,0.03 0.16,0.04 -0.05,-0.01 -0.1,-0.02 -0.16,-0.04 m 0.23,0.05 c 0.05,0.02 0.1,0.03 0.15,0.04 -0.05,-0.01 -0.1,-0.02 -0.15,-0.04 m 0.21,0.05 c 0.05,0.01 0.1,0.03 0.15,0.04 -0.05,-0.01 -0.1,-0.03 -0.15,-0.04 m 0.23,0.05 c 0.05,0.01 0.1,0.02 0.14,0.03 -0.04,-0.01 -0.09,-0.02 -0.14,-0.03 m 0.21,0.05 c 0.05,0.01 0.1,0.02 0.15,0.03 -0.05,-0.01 -0.1,-0.02 -0.15,-0.03 m 0.23,0.05 c 0.05,0.01 0.09,0.02 0.14,0.03 -0.05,-0.01 -0.09,-0.02 -0.14,-0.03 m 0.22,0.04 c 0.05,0.01 0.09,0.02 0.14,0.03 -0.05,-0.01 -0.09,-0.02 -0.14,-0.03 m 0.23,0.05 c 0.04,0.01 0.09,0.02 0.13,0.03 -0.05,-0.01 -0.09,-0.02 -0.13,-0.03 m 0.2,0.04 c 0.06,0.01 0.1,0.02 0.15,0.03 -0.05,-0.01 -0.1,-0.02 -0.15,-0.03 m 0.21,0.05 c 0.06,0.01 0.11,0.02 0.16,0.03 -0.05,-0.01 -0.11,-0.02 -0.16,-0.03 m 0.17,0.03 c 0.27,0.05 0.55,0.11 0.82,0.16 -0.27,-0.05 -0.55,-0.11 -0.82,-0.16 m 0.87,0.17 c 0.05,0.01 0.1,0.02 0.15,0.02 -0.05,-0.01 -0.1,-0.01 -0.15,-0.02 m 0.22,0.04 c 0.05,0.01 0.1,0.02 0.14,0.02 -0.05,-0.01 -0.09,-0.01 -0.14,-0.02 m 0.23,0.04 c 0.04,0.01 0.08,0.01 0.13,0.02 -0.05,-0.01 -0.09,-0.01 -0.13,-0.02 m 0.22,0.04 c 0.04,0.01 0.09,0.01 0.13,0.02 -0.04,-0.01 -0.09,-0.01 -0.13,-0.02 m 0.22,0.04 c 0.05,0.01 0.09,0.01 0.14,0.02 -0.05,-0.01 -0.09,-0.01 -0.14,-0.02 m 0.23,0.04 c 0.04,0 0.09,0.01 0.13,0.02 -0.05,-0.01 -0.09,-0.02 -0.13,-0.02 m 0.22,0.03 c 0.04,0.01 0.09,0.02 0.13,0.03 -0.04,-0.01 -0.09,-0.02 -0.13,-0.03 m 0.23,0.04 c 0.04,0.01 0.08,0.02 0.12,0.02 -0.04,0 -0.08,-0.01 -0.12,-0.02 m 0.23,0.04 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.22,0.03 c 0.04,0.01 0.08,0.02 0.12,0.02 -0.04,0 -0.08,-0.01 -0.12,-0.02 m 0.23,0.04 c 0.04,0.01 0.08,0.01 0.11,0.02 -0.03,-0.01 -0.07,-0.01 -0.11,-0.02 m 0.23,0.04 c 0.04,0 0.08,0.01 0.11,0.01 -0.03,0 -0.07,-0.01 -0.11,-0.01 m 0.21,0.03 c 0.16,0.02 0.32,0.04 0.48,0.07 -0.16,-0.03 -0.32,-0.05 -0.48,-0.07 m 0.58,0.08 c 0.04,0.01 0.07,0.01 0.11,0.02 -0.04,-0.01 -0.07,-0.01 -0.11,-0.02 m 0.22,0.03 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.23,0.03 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.22,0.03 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.24,0.03 c 0.03,0.01 0.07,0.01 0.11,0.02 -0.04,-0.01 -0.07,-0.01 -0.11,-0.02 m 0.22,0.03 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.23,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.03 c 0.04,0 0.07,0.01 0.11,0.01 -0.03,0 -0.07,-0.01 -0.11,-0.01 m 0.23,0.02 c 0.04,0.01 0.07,0.01 0.11,0.02 -0.04,-0.01 -0.07,-0.01 -0.11,-0.02 m 0.23,0.03 c 0.04,0 0.07,0.01 0.11,0.01 -0.04,0 -0.07,-0.01 -0.11,-0.01 m 0.23,0.03 c 0.03,0 0.07,0 0.11,0.01 -0.04,-0.01 -0.08,-0.01 -0.11,-0.01 m 0.23,0.02 c 0.04,0 0.07,0.01 0.11,0.01 -0.04,0 -0.08,-0.01 -0.11,-0.01 m 0.25,0.03 c 0.03,0 0.06,0 0.09,0.01 -0.03,-0.01 -0.06,-0.01 -0.09,-0.01 m 0.23,0.02 c 0.03,0 0.06,0.01 0.09,0.01 -0.03,0 -0.06,-0.01 -0.09,-0.01 m 0.23,0.02 c 0.07,0.01 0.13,0.01 0.2,0.02 -0.07,-0.01 -0.13,-0.01 -0.2,-0.02 m 0.31,0.03 c 0.04,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.07,0 -0.11,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.11,0.01 -0.03,0 -0.07,0 -0.11,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.08,0 -0.12,-0.01 m 704.45,0.02 c -0.07,0.01 -0.13,0.01 -0.2,0.02 0.07,-0.01 0.13,-0.01 0.2,-0.02 m -704.21,0 c 0.03,0.01 0.07,0.01 0.1,0.01 -0.03,0 -0.07,0 -0.1,-0.01 m 703.98,0.02 c -0.06,0 -0.13,0.01 -0.18,0.01 0.06,0 0.12,-0.01 0.18,-0.01 m -703.75,0 c 0.03,0 0.07,0.01 0.1,0.01 -0.03,0 -0.07,-0.01 -0.1,-0.01 m 703.51,0.02 c -0.05,0 -0.11,0.01 -0.17,0.01 0.06,0 0.12,-0.01 0.17,-0.01 m -703.28,0 c 0.04,0 0.07,0.01 0.1,0.01 -0.03,0 -0.06,-0.01 -0.1,-0.01 m 703.05,0.02 c -0.05,0 -0.11,0 -0.17,0.01 0.06,-0.01 0.12,-0.01 0.17,-0.01 m -702.82,0 c 0.04,0 0.07,0 0.11,0.01 -0.04,-0.01 -0.07,-0.01 -0.11,-0.01 m 702.6,0.01 c -0.06,0.01 -0.11,0.01 -0.17,0.01 0.05,0 0.11,0 0.17,-0.01 m -702.37,0 c 0.04,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.07,0 -0.11,-0.01 m 702.13,0.02 c -0.05,0 -0.1,0.01 -0.16,0.01 0.05,0 0.11,-0.01 0.16,-0.01 m -701.9,0 c 0.04,0 0.08,0 0.11,0.01 -0.03,-0.01 -0.07,-0.01 -0.11,-0.01 m 701.67,0.01 c -0.05,0.01 -0.1,0.01 -0.15,0.01 0.05,0 0.1,0 0.15,-0.01 m -701.43,0.01 c 0.03,0 0.07,0 0.1,0 -0.03,0 -0.07,0 -0.1,0 m 701.2,0.01 c -0.05,0 -0.11,0 -0.16,0.01 0.06,-0.01 0.11,-0.01 0.16,-0.01 m -700.97,0 c 0.04,0 0.07,0 0.11,0.01 -0.04,-0.01 -0.07,-0.01 -0.11,-0.01 m 700.75,0.01 c -0.05,0 -0.11,0.01 -0.16,0.01 0.05,0 0.11,-0.01 0.16,-0.01 m -700.52,0 c 0.04,0.01 0.07,0.01 0.11,0.01 -0.04,0 -0.07,0 -0.11,-0.01 m 700.29,0.01 c -0.06,0.01 -0.11,0.01 -0.17,0.01 0.06,0 0.11,0 0.17,-0.01 m -700.05,0.01 c 0.04,0 0.07,0 0.1,0 -0.03,0 -0.06,0 -0.1,0 m 699.85,0.01 c -0.2,0.01 -0.41,0.02 -0.61,0.03 0.2,-0.01 0.41,-0.02 0.61,-0.03 m -699.59,0 c 0.03,0 0.05,0 0.07,0.01 -0.02,-0.01 -0.04,-0.01 -0.07,-0.01 m 0.26,0.01 c 0.04,0.01 0.08,0.01 0.13,0.01 -0.05,0 -0.09,0 -0.13,-0.01 m 698.68,0.02 c -0.05,0 -0.09,0 -0.14,0 0.05,0 0.09,0 0.14,0 m -698.4,0 c 0.03,0 0.05,0 0.08,0 -0.03,0 -0.05,0 -0.08,0 m 698.17,0.01 c -0.04,0 -0.08,0 -0.13,0 0.05,0 0.09,0 0.13,0 m -697.94,0 c 0.03,0 0.06,0 0.09,0 -0.03,0 -0.06,0 -0.09,0 m 697.7,0.01 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -697.46,0 c 0.03,0 0.06,0 0.1,0 -0.04,0 -0.07,0 -0.1,0 m 697.23,0.01 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -697,0 c 0.03,0 0.07,0 0.1,0 -0.03,0 -0.07,0 -0.1,0 m 696.76,0 c -0.04,0 -0.07,0.01 -0.11,0.01 0.04,0 0.08,-0.01 0.11,-0.01 m -696.52,0 c 0.03,0 0.06,0.01 0.1,0.01 -0.03,0 -0.07,-0.01 -0.1,-0.01 m 696.29,0.01 c -0.04,0 -0.07,0 -0.11,0 0.04,0 0.07,0 0.11,0 m -696.06,0 c 0.03,0 0.07,0 0.1,0 -0.03,0 -0.07,0 -0.1,0 m 695.82,0.01 c -0.03,0 -0.07,0 -0.11,0 0.04,0 0.08,0 0.11,0 m -695.58,0 c 0.03,0 0.07,0 0.1,0 -0.04,0 -0.07,0 -0.1,0 m 695.35,0 c -0.04,0 -0.07,0 -0.11,0.01 0.04,-0.01 0.07,-0.01 0.11,-0.01 m -695.12,0 c 0.03,0 0.07,0 0.11,0.01 -0.04,-0.01 -0.08,-0.01 -0.11,-0.01 m 694.88,0.01 c -0.03,0 -0.07,0 -0.1,0 0.03,0 0.07,0 0.1,0 m -694.64,0 c 0.03,0 0.06,0 0.1,0 -0.04,0 -0.07,0 -0.1,0 m 694.4,0 c -0.03,0 -0.06,0 -0.1,0 0.04,0 0.07,0 0.1,0 m -694.17,0 c 0.04,0 0.07,0 0.1,0 -0.03,0 -0.06,0 -0.1,0 m 693.93,0.01 c -0.03,0 -0.06,0 -0.09,0 0.03,0 0.06,0 0.09,0 m -693.69,0 c 0.04,0 0.07,0 0.1,0 -0.03,0 -0.06,0 -0.1,0 m 693.46,0 c -0.03,0 -0.06,0 -0.1,0 0.03,0 0.07,0 0.1,0 m -693.23,0 c 0.04,0 0.07,0 0.1,0 -0.03,0 -0.06,0 -0.1,0 m 692.99,0 c -0.03,0 -0.06,0 -0.1,0 0.04,0 0.07,0 0.1,0 m -692.74,0 c 0.03,0 0.06,0 0.09,0 -0.03,0 -0.06,0 -0.09,0 m 692.49,0 c -0.03,0 -0.05,0 -0.08,0 0.03,0 0.05,0 0.08,0 m -692.25,0 c 0.03,0 0.06,0 0.09,0 -0.03,0 -0.06,0 -0.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path472",
    style: {
      fill: "#cecdcc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2649.84,1297.59 h -0.04 c 3.4,15.39 16.91,27.03 33.18,27.56 -16.26,-0.53 -29.72,-12.18 -33.14,-27.56 m 757.49,7.97 c -0.02,0 -0.04,0 -0.06,0 -5.58,11.28 -17.01,19.15 -30.32,19.59 13.32,-0.43 24.79,-8.31 30.38,-19.59 m -30.38,19.59 c -0.06,0.01 -0.13,0.01 -0.19,0.01 0.06,0 0.13,0 0.19,-0.01 m -693.96,0 c 0.06,0.01 0.12,0.01 0.18,0.01 -0.06,0 -0.12,0 -0.18,-0.01 m 693.76,0.01 c -0.13,0 -0.25,0.01 -0.38,0.01 0.13,0 0.25,-0.01 0.38,-0.01 m -693.56,0 c 0.12,0 0.25,0.01 0.37,0.01 -0.12,0 -0.25,-0.01 -0.37,-0.01 m 693.17,0.01 c -0.06,0 -0.12,0 -0.18,0 0.06,0 0.12,0 0.18,0 m -692.78,0 c 0.05,0 0.11,0 0.17,0 -0.06,0 -0.11,0 -0.17,0 m 692.57,0 c -0.05,0 -0.11,0 -0.17,0 0.06,0 0.12,0 0.17,0 m -692.37,0 c 0.06,0 0.12,0 0.17,0 -0.05,0 -0.11,0 -0.17,0 m 692.17,0 c -0.06,0 -0.12,0 -0.18,0 h -691.61 c -0.06,0 -0.12,0 -0.18,0 0.06,0 0.12,0 0.18,0 h 691.61 c 0.06,0 0.12,0 0.18,0 m -711.77,37.31 h 0.01 -0.01 m 0.2,0.05 c 0.01,0.01 0.02,0.01 0.03,0.01 -0.01,0 -0.02,0 -0.03,-0.01 m 0.21,0.06 c 0.01,0 0.02,0.01 0.03,0.01 -0.01,0 -0.02,-0.01 -0.03,-0.01 m 0.22,0.06 c 0.01,0 0.01,0 0.02,0 -0.01,0 -0.01,0 -0.02,0 m 0.21,0.05 c 0.01,0.01 0.02,0.01 0.03,0.01 -0.01,0 -0.02,0 -0.03,-0.01 m 0.21,0.06 c 0.01,0 0.02,0 0.03,0.01 -0.01,0 -0.02,-0.01 -0.03,-0.01 m 0.21,0.05 c 0.01,0.01 0.02,0.01 0.04,0.01 -0.02,0 -0.03,0 -0.04,-0.01 m 1.67,0.41 c 0.02,0.01 0.03,0.01 0.05,0.01 -0.02,0 -0.03,0 -0.05,-0.01 m 0.21,0.05 c 0.02,0.01 0.04,0.01 0.05,0.01 -0.01,0 -0.03,0 -0.05,-0.01 m 0.21,0.05 c 0.02,0 0.05,0.01 0.07,0.01 -0.02,0 -0.04,0 -0.07,-0.01 m 0.22,0.05 c 0.02,0 0.04,0.01 0.06,0.01 -0.02,0 -0.04,-0.01 -0.06,-0.01 m 0.21,0.05 c 0.03,0 0.05,0.01 0.08,0.01 -0.03,0 -0.05,-0.01 -0.08,-0.01 m 0.22,0.04 c 0.03,0.01 0.05,0.01 0.07,0.02 -0.02,-0.01 -0.04,-0.01 -0.07,-0.02 m 0.22,0.05 c 0.03,0.01 0.05,0.01 0.08,0.02 -0.03,-0.01 -0.06,-0.01 -0.08,-0.02 m 0.22,0.05 c 0.03,0 0.05,0.01 0.08,0.01 -0.03,0 -0.05,-0.01 -0.08,-0.01 m 0.22,0.04 c 0.03,0.01 0.06,0.02 0.09,0.02 -0.03,0 -0.06,-0.01 -0.09,-0.02 m 0.22,0.05 c 0.02,0 0.05,0.01 0.07,0.01 -0.02,0 -0.04,-0.01 -0.07,-0.01 m 0.22,0.04 c 0.02,0.01 0.04,0.01 0.06,0.02 -0.02,-0.01 -0.04,-0.01 -0.06,-0.02 m 0.22,0.05 c 0.01,0 0.01,0 0.01,0 0,0 0,0 -0.01,0 m 0.83,0.16 c 0.02,0 0.03,0 0.05,0.01 -0.02,-0.01 -0.03,-0.01 -0.05,-0.01 m 0.2,0.03 c 0.02,0.01 0.05,0.01 0.07,0.02 -0.02,-0.01 -0.05,-0.01 -0.07,-0.02 m 0.21,0.04 c 0.03,0.01 0.06,0.01 0.09,0.02 -0.03,-0.01 -0.06,-0.01 -0.09,-0.02 m 0.22,0.04 c 0.03,0.01 0.06,0.01 0.09,0.02 -0.03,-0.01 -0.06,-0.01 -0.09,-0.02 m 0.22,0.04 c 0.03,0.01 0.06,0.01 0.09,0.02 -0.03,-0.01 -0.06,-0.01 -0.09,-0.02 m 0.23,0.04 c 0.02,0.01 0.06,0.01 0.09,0.02 -0.04,-0.01 -0.06,-0.01 -0.09,-0.02 m 0.22,0.04 c 0.03,0 0.06,0.01 0.09,0.01 -0.03,0 -0.06,-0.01 -0.09,-0.01 m 0.22,0.04 c 0.03,0 0.06,0.01 0.1,0.01 -0.03,0 -0.07,-0.01 -0.1,-0.01 m 0.22,0.03 c 0.04,0.01 0.07,0.01 0.11,0.02 -0.04,-0.01 -0.07,-0.01 -0.11,-0.02 m 0.23,0.04 c 0.03,0 0.07,0.01 0.1,0.01 -0.03,0 -0.07,-0.01 -0.1,-0.01 m 0.22,0.03 c 0.04,0.01 0.08,0.02 0.11,0.02 -0.03,0 -0.07,-0.01 -0.11,-0.02 m 0.22,0.04 c 0.05,0 0.08,0.01 0.12,0.02 -0.03,-0.01 -0.08,-0.02 -0.12,-0.02 m 0.23,0.03 c 0.04,0.01 0.07,0.01 0.1,0.02 -0.03,-0.01 -0.06,-0.01 -0.1,-0.02 m 0.58,0.09 c 0.03,0 0.07,0.01 0.1,0.01 -0.04,0 -0.07,-0.01 -0.1,-0.01 m 0.21,0.03 c 0.04,0 0.08,0.01 0.11,0.01 -0.03,0 -0.07,-0.01 -0.11,-0.01 m 0.23,0.03 c 0.04,0 0.07,0.01 0.11,0.01 -0.04,0 -0.07,-0.01 -0.11,-0.01 m 0.23,0.03 c 0.04,0 0.07,0.01 0.1,0.01 -0.03,0 -0.06,-0.01 -0.1,-0.01 m 0.22,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.03 c 0.03,0 0.08,0.01 0.11,0.01 -0.04,0 -0.07,-0.01 -0.11,-0.01 m 0.23,0.03 c 0.04,0 0.07,0 0.11,0.01 -0.03,-0.01 -0.07,-0.01 -0.11,-0.01 m 0.23,0.02 c 0.03,0.01 0.07,0.01 0.11,0.02 -0.04,-0.01 -0.08,-0.01 -0.11,-0.02 m 0.22,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.12,0.02 -0.04,-0.01 -0.08,-0.01 -0.12,-0.02 m 0.23,0.03 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 0.23,0.02 c 0.05,0.01 0.09,0.01 0.14,0.02 -0.05,-0.01 -0.09,-0.01 -0.14,-0.02 m 0.23,0.03 c 0.04,0 0.09,0 0.14,0.01 -0.05,0 -0.1,-0.01 -0.14,-0.01 m 0.23,0.02 c 0.04,0 0.1,0.01 0.14,0.01 -0.04,0 -0.09,-0.01 -0.14,-0.01 m 0.34,0.03 c 0.04,0 0.07,0.01 0.11,0.01 -0.03,0 -0.07,-0.01 -0.11,-0.01 m 0.22,0.02 c 0.04,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.08,0 -0.12,-0.01 m 0.23,0.02 c 0.04,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.08,0 -0.12,-0.01 m 0.24,0.02 c 0.03,0.01 0.08,0.01 0.12,0.01 -0.04,0 -0.09,0 -0.12,-0.01 m 704.34,0.01 c -0.01,0 -0.01,0 -0.01,0 h 0.01 m -704.12,0.01 c 0.05,0.01 0.09,0.01 0.13,0.01 -0.04,0 -0.08,0 -0.13,-0.01 m 703.91,0.01 c -0.01,0 -0.02,0 -0.03,0 0.01,0 0.02,0 0.03,0 m -703.68,0.01 c 0.05,0 0.09,0.01 0.13,0.01 -0.04,0 -0.08,-0.01 -0.13,-0.01 m 703.47,0 c -0.02,0 -0.04,0.01 -0.06,0.01 0.02,0 0.04,-0.01 0.06,-0.01 m -703.24,0.02 c 0.05,0 0.09,0 0.13,0.01 -0.04,-0.01 -0.08,-0.01 -0.13,-0.01 m 703.01,0 c -0.02,0 -0.04,0 -0.06,0.01 0.02,-0.01 0.04,-0.01 0.06,-0.01 m -702.77,0.02 c 0.04,0 0.08,0 0.12,0 -0.04,0 -0.08,0 -0.12,0 m 702.54,0 c -0.02,0 -0.03,0 -0.05,0 0.02,0 0.03,0 0.05,0 m -702.31,0.01 c 0.04,0 0.08,0.01 0.12,0.01 -0.04,0 -0.08,-0.01 -0.12,-0.01 m 702.09,0 c -0.02,0 -0.04,0.01 -0.07,0.01 0.03,0 0.05,-0.01 0.07,-0.01 m -701.86,0.02 c 0.05,0 0.09,0 0.13,0.01 -0.04,-0.01 -0.08,-0.01 -0.13,-0.01 m 701.63,0 c -0.02,0 -0.04,0 -0.07,0 0.03,0 0.05,0 0.07,0 m -701.4,0.01 c 0.04,0 0.09,0.01 0.13,0.01 -0.04,0 -0.09,-0.01 -0.13,-0.01 m 701.18,0 c -0.03,0 -0.05,0.01 -0.08,0.01 0.03,0 0.05,-0.01 0.08,-0.01 m -700.94,0.02 c 0.04,0 0.08,0 0.12,0 -0.04,0 -0.08,0 -0.12,0 m 700.7,0 c -0.02,0 -0.04,0 -0.06,0 0.02,0 0.04,0 0.06,0 m -700.47,0.01 c 0.04,0 0.09,0.01 0.13,0.01 -0.04,0 -0.09,-0.01 -0.13,-0.01 m 700.25,0 c -0.03,0 -0.05,0 -0.07,0 0.02,0 0.04,0 0.07,0 m -700.02,0.01 c 0.06,0.01 0.11,0.01 0.16,0.01 -0.05,0 -0.1,0 -0.16,-0.01 m 699.78,0 c -0.01,0 -0.02,0 -0.03,0.01 0.01,-0.01 0.02,-0.01 0.03,-0.01 m -699.55,0.02 c 0.06,0 0.13,0 0.19,0 -0.06,0 -0.13,0 -0.19,0 m 0.32,0.01 c 0.05,0 0.1,0.01 0.15,0.01 -0.05,0 -0.1,-0.01 -0.15,-0.01 m 698.59,0.01 c -0.01,0 -0.02,0 -0.04,0 0.02,0 0.03,0 0.04,0 m -698.36,0 c 0.05,0 0.1,0.01 0.15,0.01 -0.05,0 -0.1,-0.01 -0.15,-0.01 m 698.18,0 c -0.03,0 -0.06,0.01 -0.09,0.01 0.03,0 0.06,-0.01 0.09,-0.01 m -697.94,0.01 c 0.05,0 0.1,0 0.15,0.01 -0.05,0 -0.1,-0.01 -0.15,-0.01 m 697.72,0 c -0.03,0 -0.07,0.01 -0.11,0.01 0.04,0 0.08,-0.01 0.11,-0.01 m -697.47,0.01 c 0.04,0 0.09,0 0.13,0.01 -0.05,-0.01 -0.09,-0.01 -0.13,-0.01 m 697.24,0 c -0.03,0 -0.07,0 -0.11,0.01 0.04,-0.01 0.07,-0.01 0.11,-0.01 m -697.01,0.01 c 0.05,0 0.09,0 0.14,0 -0.05,0 -0.09,0 -0.14,0 m 696.78,0 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -696.54,0.01 c 0.04,0 0.08,0 0.13,0 -0.05,0 -0.09,0 -0.13,0 m 696.31,0 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -696.08,0 c 0.05,0 0.09,0.01 0.14,0.01 -0.05,0 -0.09,-0.01 -0.14,-0.01 m 695.85,0 c -0.05,0 -0.09,0.01 -0.13,0.01 0.04,0 0.08,-0.01 0.13,-0.01 m -695.61,0.01 c 0.04,0 0.08,0 0.13,0 -0.05,0 -0.09,0 -0.13,0 m 695.37,0 c -0.04,0 -0.08,0 -0.12,0 0.04,0 0.08,0 0.12,0 m -695.13,0.01 c 0.04,0 0.08,0 0.13,0 -0.05,0 -0.09,0 -0.13,0 m 694.9,0 c -0.05,0 -0.09,0 -0.13,0 0.04,0 0.09,0 0.13,0 m -694.67,0 c 0.04,0 0.09,0 0.13,0 -0.04,0 -0.09,0 -0.13,0 m 694.44,0 c -0.05,0 -0.09,0 -0.14,0 0.05,0 0.09,0 0.14,0 m -694.21,0 c 0.05,0 0.1,0.01 0.14,0.01 -0.05,0 -0.09,-0.01 -0.14,-0.01 m 693.97,0 c -0.05,0 -0.09,0.01 -0.14,0.01 0.05,0 0.1,-0.01 0.14,-0.01 m -693.73,0.01 c 0.04,0 0.09,0 0.13,0 -0.04,0 -0.09,0 -0.13,0 m 693.5,0 c -0.05,0 -0.09,0 -0.14,0 0.04,0 0.09,0 0.14,0 m -693.27,0 c 0.05,0 0.1,0 0.15,0 -0.05,0 -0.1,0 -0.15,0 m 693.03,0 c -0.05,0 -0.1,0 -0.14,0 0.04,0 0.09,0 0.14,0 m -692.79,0 c 0.05,0 0.1,0 0.15,0 -0.05,0 -0.1,0 -0.15,0 m 692.55,0 c -0.05,0 -0.1,0 -0.15,0 0.05,0 0.11,0 0.15,0 m -692.31,0 c 0.07,0 0.15,0 0.23,0 -0.08,0 -0.16,0 -0.23,0 m 692.08,0 c -0.08,0 -0.16,0 -0.24,0 0.08,0 0.16,0 0.24,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path474",
    style: {
      fill: "#263136",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2649.8,1297.59 h -40.44 c 3.14,31.15 25.39,56.76 54.82,64.89 h 0.01 c 0.07,0.02 0.13,0.04 0.19,0.05 0.01,0.01 0.02,0.01 0.03,0.01 0.06,0.02 0.12,0.03 0.18,0.05 0.01,0 0.02,0.01 0.03,0.01 0.06,0.02 0.13,0.03 0.19,0.05 0.01,0 0.01,0 0.02,0 0.06,0.02 0.12,0.04 0.19,0.05 0.01,0.01 0.02,0.01 0.03,0.01 0.06,0.02 0.12,0.03 0.18,0.05 0.01,0 0.02,0.01 0.03,0.01 0.06,0.01 0.12,0.03 0.18,0.04 0.01,0.01 0.02,0.01 0.04,0.01 0.54,0.14 1.08,0.28 1.63,0.4 0.02,0.01 0.03,0.01 0.05,0.01 0.05,0.02 0.11,0.03 0.16,0.04 0.02,0.01 0.04,0.01 0.05,0.01 0.06,0.02 0.11,0.03 0.16,0.04 0.03,0.01 0.05,0.01 0.07,0.01 0.05,0.02 0.1,0.03 0.15,0.04 0.02,0 0.04,0.01 0.06,0.01 0.05,0.01 0.1,0.03 0.15,0.04 0.03,0 0.05,0.01 0.08,0.01 0.05,0.01 0.1,0.02 0.14,0.03 0.03,0.01 0.05,0.01 0.07,0.02 0.05,0.01 0.1,0.02 0.15,0.03 0.02,0.01 0.05,0.01 0.08,0.02 0.05,0.01 0.09,0.02 0.14,0.03 0.03,0 0.05,0.01 0.08,0.01 0.05,0.01 0.09,0.02 0.14,0.03 0.03,0.01 0.06,0.02 0.09,0.02 0.04,0.01 0.08,0.02 0.13,0.03 0.03,0 0.05,0.01 0.07,0.01 0.05,0.01 0.1,0.02 0.15,0.03 0.02,0.01 0.04,0.01 0.06,0.02 0.05,0.01 0.11,0.02 0.16,0.03 0.01,0 0.01,0 0.01,0 0.27,0.05 0.55,0.11 0.82,0.16 0.02,0 0.03,0 0.05,0.01 0.05,0.01 0.1,0.01 0.15,0.02 0.02,0.01 0.05,0.01 0.07,0.02 0.05,0.01 0.09,0.01 0.14,0.02 0.03,0.01 0.06,0.01 0.09,0.02 0.04,0.01 0.08,0.01 0.13,0.02 0.03,0.01 0.06,0.01 0.09,0.02 0.04,0.01 0.09,0.01 0.13,0.02 0.03,0.01 0.06,0.01 0.09,0.02 0.05,0.01 0.09,0.01 0.14,0.02 0.03,0.01 0.05,0.01 0.09,0.02 0.04,0 0.08,0.01 0.13,0.02 0.03,0 0.06,0.01 0.09,0.01 0.04,0.01 0.09,0.02 0.13,0.03 0.03,0 0.07,0.01 0.1,0.01 0.04,0.01 0.08,0.02 0.12,0.02 0.04,0.01 0.07,0.01 0.11,0.02 0.04,0.01 0.08,0.01 0.12,0.02 0.03,0 0.07,0.01 0.1,0.01 0.04,0.01 0.08,0.02 0.12,0.02 0.04,0.01 0.08,0.02 0.11,0.02 0.04,0.01 0.08,0.01 0.11,0.02 0.04,0 0.09,0.01 0.12,0.02 0.04,0 0.08,0.01 0.11,0.01 0.04,0.01 0.07,0.01 0.1,0.02 0.16,0.02 0.32,0.04 0.48,0.07 0.03,0 0.06,0.01 0.1,0.01 0.04,0.01 0.07,0.01 0.11,0.02 0.04,0 0.08,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.04,0 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.04,0 0.07,0.01 0.1,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.04,0 0.08,0.01 0.12,0.01 0.04,0.01 0.07,0.01 0.11,0.02 0.04,0 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.04,0 0.08,0 0.11,0.01 0.04,0 0.08,0.01 0.12,0.01 0.03,0.01 0.07,0.01 0.11,0.02 0.04,0 0.08,0.01 0.11,0.01 0.04,0 0.08,0.01 0.12,0.01 0.04,0.01 0.07,0.01 0.11,0.02 0.04,0 0.08,0.01 0.12,0.01 0.04,0 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.02 0.03,0 0.07,0 0.11,0.01 0.04,0 0.08,0.01 0.12,0.01 0.03,0 0.07,0.01 0.11,0.01 0.05,0.01 0.09,0.01 0.14,0.02 0.03,0 0.06,0 0.09,0.01 0.04,0 0.09,0.01 0.14,0.01 0.03,0 0.06,0.01 0.09,0.01 0.05,0 0.1,0.01 0.14,0.01 0.07,0.01 0.13,0.01 0.2,0.02 0.04,0 0.08,0.01 0.11,0.01 0.04,0.01 0.07,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.01 0.04,0.01 0.08,0.01 0.11,0.01 0.04,0.01 0.08,0.01 0.12,0.01 0.04,0.01 0.08,0.01 0.12,0.01 0.03,0.01 0.08,0.01 0.12,0.01 0.03,0.01 0.07,0.01 0.1,0.01 0.05,0.01 0.09,0.01 0.13,0.01 0.03,0 0.07,0.01 0.1,0.01 0.05,0 0.09,0.01 0.13,0.01 0.04,0 0.07,0.01 0.1,0.01 0.05,0 0.09,0 0.13,0.01 0.04,0 0.07,0 0.11,0.01 0.04,0 0.08,0 0.12,0 0.04,0.01 0.07,0.01 0.11,0.01 0.04,0 0.08,0.01 0.12,0.01 0.04,0 0.08,0 0.11,0.01 0.05,0 0.09,0 0.13,0.01 0.03,0 0.07,0 0.1,0 0.04,0 0.09,0.01 0.13,0.01 0.04,0 0.07,0 0.11,0.01 0.04,0 0.08,0 0.12,0 0.04,0.01 0.07,0.01 0.11,0.01 0.04,0 0.09,0.01 0.13,0.01 0.04,0 0.07,0 0.1,0 0.06,0.01 0.11,0.01 0.16,0.01 0.03,0 0.05,0 0.07,0.01 0.06,0 0.13,0 0.19,0 0.04,0.01 0.08,0.01 0.13,0.01 0.05,0 0.1,0.01 0.15,0.01 0.03,0 0.05,0 0.08,0 0.05,0 0.1,0.01 0.15,0.01 0.03,0 0.06,0 0.09,0 0.05,0 0.1,0.01 0.15,0.01 0.03,0 0.06,0 0.1,0 0.04,0 0.08,0 0.13,0.01 0.03,0 0.07,0 0.1,0 0.05,0 0.09,0 0.14,0 0.03,0 0.07,0.01 0.1,0.01 0.04,0 0.08,0 0.13,0 0.03,0 0.07,0 0.1,0 0.05,0 0.09,0.01 0.14,0.01 0.03,0 0.06,0 0.1,0 0.04,0 0.08,0 0.13,0 0.03,0 0.07,0 0.11,0.01 0.04,0 0.08,0 0.13,0 0.03,0 0.06,0 0.1,0 0.04,0 0.09,0 0.13,0 0.04,0 0.07,0 0.1,0 0.05,0 0.09,0.01 0.14,0.01 0.04,0 0.07,0 0.1,0 0.04,0 0.09,0 0.13,0 0.04,0 0.07,0 0.1,0 0.05,0 0.1,0 0.15,0 0.03,0 0.06,0 0.09,0 0.05,0 0.1,0 0.15,0 0.03,0 0.06,0 0.09,0 0.07,0 0.15,0 0.23,0 v 0 h 691.61 v 0 c 0.08,0 0.16,0 0.24,0 0.03,0 0.05,0 0.08,0 0.05,0 0.1,0 0.15,0 0.04,0 0.07,0 0.1,0 0.04,0 0.09,0 0.14,0 0.04,0 0.07,0 0.1,0 0.05,0 0.09,0 0.14,0 0.03,0 0.06,0 0.09,0 0.05,0 0.09,-0.01 0.14,-0.01 0.04,0 0.07,0 0.1,0 0.05,0 0.09,0 0.14,0 0.03,0 0.07,0 0.1,0 0.04,0 0.08,0 0.13,0 0.04,-0.01 0.07,-0.01 0.11,-0.01 0.04,0 0.08,0 0.12,0 0.04,0 0.08,0 0.11,0 0.04,0 0.08,-0.01 0.13,-0.01 0.04,0 0.07,0 0.11,0 0.04,0 0.08,0 0.12,0 0.04,0 0.07,-0.01 0.11,-0.01 0.04,0 0.08,0 0.12,0 0.04,0 0.08,0 0.12,0 0.04,-0.01 0.08,-0.01 0.11,-0.01 0.04,0 0.08,0 0.12,0 0.04,0 0.08,-0.01 0.11,-0.01 0.05,0 0.09,0 0.13,0 0.03,0 0.06,-0.01 0.09,-0.01 0.05,0 0.09,0 0.14,0 0.02,0 0.03,0 0.04,0 0.2,-0.01 0.41,-0.02 0.61,-0.03 0.01,-0.01 0.02,-0.01 0.03,-0.01 0.06,0 0.11,0 0.17,-0.01 0.02,0 0.04,0 0.07,0 0.05,0 0.11,-0.01 0.16,-0.01 0.02,0 0.04,0 0.06,0 0.05,-0.01 0.11,-0.01 0.16,-0.01 0.03,0 0.05,-0.01 0.08,-0.01 0.05,0 0.1,0 0.15,-0.01 0.03,0 0.05,0 0.07,0 0.06,0 0.11,-0.01 0.16,-0.01 0.03,0 0.05,-0.01 0.07,-0.01 0.06,0 0.11,0 0.17,-0.01 0.02,0 0.03,0 0.05,0 0.06,-0.01 0.12,-0.01 0.17,-0.01 0.02,-0.01 0.04,-0.01 0.06,-0.01 0.06,0 0.12,-0.01 0.17,-0.01 0.02,0 0.04,-0.01 0.06,-0.01 0.05,0 0.12,-0.01 0.18,-0.01 0.01,0 0.02,0 0.03,0 0.07,-0.01 0.13,-0.01 0.2,-0.02 0,0 0,0 0.01,0 33.28,-2.79 60.47,-27.34 67.24,-59.35 -13.65,0 -27.62,0 -42.01,0 -5.59,11.28 -17.06,19.16 -30.38,19.59 v 0 c -0.06,0.01 -0.13,0.01 -0.19,0.01 h -0.01 c -0.13,0 -0.25,0.01 -0.38,0.01 h -0.01 c -0.06,0 -0.12,0 -0.18,0 -0.01,0 -0.02,0 -0.03,0 -0.05,0 -0.11,0 -0.17,0 -0.01,0 -0.02,0 -0.03,0 -0.06,0 -0.12,0 -0.18,0 h -691.61 c -0.06,0 -0.12,0 -0.18,0 -0.01,0 -0.02,0 -0.03,0 -0.05,0 -0.11,0 -0.17,0 -0.01,0 -0.02,0 -0.03,0 -0.06,0 -0.12,0 -0.17,0 -0.01,0 -0.01,0 -0.02,0 -0.12,0 -0.25,-0.01 -0.37,-0.01 -0.01,0 -0.01,0 -0.02,0 -0.06,0 -0.12,0 -0.18,-0.01 h -0.01 c -16.27,-0.53 -29.78,-12.17 -33.18,-27.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path476",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2132.07,1118.06 H 1358.6 c -46.52,0 -84.23,-37.71 -84.23,-84.23 V 243.41 c 0,-46.531 37.71,-84.23 84.23,-84.23 h 773.47 c 46.52,0 84.23,37.699 84.23,84.23 v 790.42 c 0,46.52 -37.71,84.23 -84.23,84.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path478",
    style: {
      fill: "#8daee0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1274.37,243.41 v 0 790.42 c 0,46.52 37.71,84.23 84.23,84.23 h 773.47 v 0 0 h -214.43 c -46.52,0 -84.23,-37.71 -84.23,-84.23 V 244.078 h -559.04 v -0.668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path480",
    style: {
      fill: "#799cd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1917.64,159.18 H 1358.6 c -46.52,0 -84.23,37.699 -84.23,84.23 v 0.668 h 559.04 v -0.668 c 0,-46.531 37.71,-84.23 84.23,-84.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path482",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2132.07,159.18 h -214.43 c -46.52,0 -84.23,37.699 -84.23,84.23 v 790.42 c 0,46.52 37.71,84.23 84.23,84.23 h 214.43 c 46.52,0 84.23,-37.71 84.23,-84.23 V 243.41 c 0,-46.531 -37.71,-84.23 -84.23,-84.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path484",
    style: {
      fill: "#799bd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2132.07,204.18 h -214.43 c -21.63,0 -39.23,17.59 -39.23,39.23 v 790.42 c 0,21.64 17.6,39.23 39.23,39.23 h 214.43 c 21.63,0 39.23,-17.59 39.23,-39.23 V 243.41 c 0,-21.64 -17.6,-39.23 -39.23,-39.23 m -107.21,483.39 c -27.04,0 -48.95,-21.922 -48.95,-48.949 0,-27.043 21.91,-48.953 48.95,-48.953 27.03,0 48.95,21.91 48.95,48.953 0,27.027 -21.92,48.949 -48.95,48.949 m -117.5,247.989 v -62.5 h 235 v 62.5 h -235 m 0,75.001 v -62.501 h 235 v 62.501 h -235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path486",
    style: {
      fill: "#d9e6f6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1907.36,948.059 h 235 v 62.5 h -235 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path488",
    style: {
      fill: "#d9e6f6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1907.36,873.059 h 235 v 62.5 h -235 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path490",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2073.81,638.621 c 0,-27.043 -21.92,-48.953 -48.95,-48.953 -27.04,0 -48.95,21.91 -48.95,48.953 0,27.027 21.91,48.949 48.95,48.949 27.03,0 48.95,-21.922 48.95,-48.949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path492",
    style: {
      fill: "#eff5fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2024.86,610.109 c -24.07,0 -34.52,28.903 -18.96,45.77 1.09,1.18 2.34,1.672 3.55,1.672 4,0 7.61,-5.36 4.03,-9.25 -9.31,-10.09 -3.13,-27.469 11.3,-27.469 0.03,0 0.05,0 0.08,0 14.44,0.066 20.75,17.297 11.38,27.469 -3.59,3.89 0.03,9.25 4.02,9.25 1.21,0 2.46,-0.492 3.55,-1.672 15.56,-16.867 5.12,-45.77 -18.95,-45.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path494",
    style: {
      fill: "#eff5fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2024.86,637.59 c -2.68,0 -5.36,1.719 -5.36,5.172 0,8.136 0,16.269 0,24.398 0,3.461 2.67,5.18 5.35,5.18 2.68,0 5.36,-1.731 5.36,-5.18 0,-8.129 0,-16.262 0,-24.398 0,-3.453 -2.67,-5.172 -5.35,-5.172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path496",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1947.16,493.891 c 0,-8.282 -6.72,-15 -15,-15 -8.29,0 -15,6.718 -15,15 0,8.289 6.71,15 15,15 8.28,0 15,-6.711 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path498",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2008.96,493.891 c 0,-8.282 -6.72,-15 -15,-15 -8.29,0 -15,6.718 -15,15 0,8.289 6.71,15 15,15 8.28,0 15,-6.711 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path500",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2070.75,493.891 c 0,-8.282 -6.71,-15 -15,-15 -8.28,0 -15,6.718 -15,15 0,8.289 6.72,15 15,15 8.29,0 15,-6.711 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path502",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2132.56,493.891 c 0,-8.282 -6.72,-15 -15,-15 -8.29,0 -15,6.718 -15,15 0,8.289 6.71,15 15,15 8.28,0 15,-6.711 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path504",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1978.06,440.559 c 0,-8.289 -6.72,-15 -15,-15 -8.29,0 -15,6.711 -15,15 0,8.281 6.71,15 15,15 8.28,0 15,-6.719 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path506",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2039.86,440.559 c 0,-8.289 -6.72,-15 -15,-15 -8.29,0 -15,6.711 -15,15 0,8.281 6.71,15 15,15 8.28,0 15,-6.719 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path508",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2101.66,440.559 c 0,-8.289 -6.72,-15 -15,-15 -8.29,0 -15,6.711 -15,15 0,8.281 6.71,15 15,15 8.28,0 15,-6.719 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path510",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1947.16,381.48 c 0,-8.281 -6.72,-15 -15,-15 -8.29,0 -15,6.719 -15,15 0,8.29 6.71,15 15,15 8.28,0 15,-6.71 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path512",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2008.96,381.48 c 0,-8.281 -6.72,-15 -15,-15 -8.29,0 -15,6.719 -15,15 0,8.29 6.71,15 15,15 8.28,0 15,-6.71 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path514",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2070.75,381.48 c 0,-8.281 -6.71,-15 -15,-15 -8.28,0 -15,6.719 -15,15 0,8.29 6.72,15 15,15 8.29,0 15,-6.71 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path516",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2132.56,381.48 c 0,-8.281 -6.72,-15 -15,-15 -8.29,0 -15,6.719 -15,15 0,8.29 6.71,15 15,15 8.28,0 15,-6.71 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path518",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1978.06,328.148 c 0,-8.277 -6.72,-15 -15,-15 -8.29,0 -15,6.723 -15,15 0,8.282 6.71,15 15,15 8.28,0 15,-6.718 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path520",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2039.86,328.148 c 0,-8.277 -6.72,-15 -15,-15 -8.29,0 -15,6.723 -15,15 0,8.282 6.71,15 15,15 8.28,0 15,-6.718 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path522",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2101.66,328.148 c 0,-8.277 -6.72,-15 -15,-15 -8.29,0 -15,6.723 -15,15 0,8.282 6.71,15 15,15 8.28,0 15,-6.718 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path524",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1947.16,269.078 c 0,-8.289 -6.72,-15 -15,-15 -8.29,0 -15,6.711 -15,15 0,8.281 6.71,15 15,15 8.28,0 15,-6.719 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path526",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2008.96,269.078 c 0,-8.289 -6.72,-15 -15,-15 -8.29,0 -15,6.711 -15,15 0,8.281 6.71,15 15,15 8.28,0 15,-6.719 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path528",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2070.75,269.078 c 0,-8.289 -6.71,-15 -15,-15 -8.28,0 -15,6.711 -15,15 0,8.281 6.72,15 15,15 8.29,0 15,-6.719 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path530",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2132.56,269.078 c 0,-8.289 -6.72,-15 -15,-15 -8.29,0 -15,6.711 -15,15 0,8.281 6.71,15 15,15 8.28,0 15,-6.719 15,-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path532",
    style: {
      fill: "#f9b0bb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3301.28,1560.83 -60.41,27.22 -84.68,-35.31 v -42.16 l 131.44,4.18 c 0,0 148.29,-49.37 203.06,-41.77 54.76,7.59 229.17,250.65 229.17,250.65 l -87.63,76.71 -166.82,-237.74 -164.13,-1.78"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g534"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath540)",
    id: "g536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path542",
    style: {
      fill: "#e8e8e7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3287.63,1511.48 h 10.1602 v 3.2813 H 3287.63 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path544",
    style: {
      fill: "#f59fa4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3297.79,1511.48 c -6.33,2.01 -10.01,3.23 -10.16,3.28 v 0 0 0 0 l -26.65,-0.84 c 12.69,13.57 26.32,29.66 40.17,46.96 l 0.13,-0.05 38.94,0.42 -42.43,-49.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path546",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3573.25,1731.23 c 0,0 60.67,107.86 99.42,142.04 23.53,20.74 56.33,27.21 78.47,29.08 13.92,1.18 25.83,-9.86 25.93,-23.84 0.31,-42.62 -10.79,-135.38 -98.5,-230.83 l -105.32,83.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path548",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3573.25,1751.55 c 0,0 73.86,-34.75 117.12,-103.11 l -23.59,-18.23 c 0,0 -48.11,60.67 -108.27,95.51 l 14.74,25.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path550",
    style: {
      fill: "#f36679",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3425.03,2140.94 -29.94,-47.04 c 0,0 15.6,-11.51 37.44,-3.67 l -7.5,50.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path552",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3419.93,2174.93 c -14.23,0 -25.82,-12.61 -25.82,-28.12 0,-15.51 11.59,-28.13 25.82,-28.13 14.23,0 25.81,12.62 25.81,28.13 0,15.51 -11.58,28.12 -25.81,28.12 z m 0,-63.75 c -18.37,0 -33.32,15.99 -33.32,35.63 0,19.64 14.95,35.62 33.32,35.62 18.37,0 33.31,-15.98 33.31,-35.62 0,-19.64 -14.94,-35.63 -33.31,-35.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path554",
    style: {
      fill: "#14272d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3406.99,2147.5 c -0.06,-6.07 3.03,-11.05 7.01,-11.1 3.97,-0.05 7.52,5.08 7.42,10.98 -0.1,5.9 -3.03,11.05 -7.02,11.04 -3.99,-0.01 -7.28,-4.87 -7.41,-10.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556",
    style: {
      fill: "#f9b0bb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3641.24,2185.41 c 2.67,-80.69 5.55,-114.85 -31.07,-159.86 -57.95,-47.78 -154.91,-53.4 -181.63,24.93 -24.07,70.47 -24.4,190.3 51.15,230.12 53.86,28.37 120.51,7.7 148.88,-46.16 7.96,-15.14 12.31,-31.92 12.67,-49.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path558",
    style: {
      fill: "#df999c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3515.91,1990.62 c -14.01,0 -27.56,2.43 -39.84,7.59 l 32.8,8.98 c 1.31,0.36 2.62,0.53 3.91,0.53 7.02,0 13.33,-5.08 14.51,-12.36 l 0.61,-4.17 c -4.02,-0.38 -8.02,-0.57 -11.99,-0.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560",
    style: {
      fill: "#14272d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3428.83,2175 c -1.06,-0.11 -2.12,0.3 -2.83,1.1 -5,6.29 -12.72,9.78 -20.75,9.39 -1.73,-0.21 -3.3,1 -3.54,2.72 -0.19,1.74 1.03,3.32 2.76,3.56 10.16,0.72 20.02,-3.59 26.39,-11.54 1.14,-1.34 0.99,-3.34 -0.35,-4.49 l -0.01,-0.01 -1.67,-0.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path562",
    style: {
      fill: "#f9b0bb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3524.89,2011.58 17.69,-119.84 100.09,20.72 -32.06,122.66 -85.72,-23.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path564",
    style: {
      fill: "#14272d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3424.63,2250.84 c 34.05,-64.84 57.66,-5.53 51.4,-57.8 -6.26,-52.26 12.52,-69.19 12.52,-69.19 l 68.56,-102.26 c 3.62,-5.4 10.59,-7.19 16.55,-4.57 17.8,7.8 29.33,6.09 35.67,3.51 4.46,-1.81 9.45,-1.27 13.05,1.91 15.48,13.7 52.22,52.96 63.51,124.96 22.11,141.09 -86.3,162.6 -86.3,162.6 -60.25,12.52 -44.81,76.37 -80.61,76.36 -27.3,-0.01 -19.26,-44.94 -19.26,-44.94 0,0 -29.24,21.9 -46.2,14.45 -21.89,-9.63 -2.47,-54.57 -2.47,-54.57 0,0 -59.8,13.12 -26.42,-50.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path566",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3495.11,2161.81 h -100.02 l 4.81,10 h 95.21 v -10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568",
    style: {
      fill: "#f9b1bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3474.59,2149.47 c -2.9,-16.24 0.79,-32.96 10.26,-46.47 12.69,-17.83 32.9,-9.88 40.97,9.16 7.32,17.24 9.39,47.14 -8.98,58.29 -18.37,11.14 -38.48,-1.17 -42.25,-20.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path570",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3497.9,1935.56 c 0,0 64.26,60.74 131.67,55.83 45.83,-3.33 60,-60.83 60,-60.83 l -191.67,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path572",
    style: {
      fill: "#45555c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3687.52,1937.15 c -40.17,8.36 -87.6,11.1 -132.65,11.1 -14.58,0 -28.91,-0.28 -42.66,-0.76 21.43,16.47 64.22,44.19 109.53,44.19 2.6,0 5.21,-0.1 7.83,-0.29 36.19,-2.63 52.63,-39.03 57.95,-54.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path574",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3541.31,1200.56 -140.84,687.57 c -5.63,27.53 12.97,52.81 40.6,55.11 88.33,7.37 266.45,14.49 326.01,-40.18 138.84,-127.45 149.84,-712.5 149.84,-712.5 l -375.61,10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path576",
    style: {
      fill: "#151717",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3449.4,1649.26 -14.93,72.9 c 33.14,55.39 47.4,107.07 53.15,146.66 -1.38,-50.14 -8.03,-151.94 -38.22,-219.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path578",
    style: {
      fill: "#f9b0bb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3020.56,1569.44 -59.74,29.87 -83.75,-38.75 v -46.25 l 130,4.58 c 0,0 146.66,-54.17 200.83,-45.83 54.17,8.33 226.67,275 226.67,275 l -86.67,84.16 -165,-260.83 -162.34,-1.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path580",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3289.57,1756.39 c 0,0 60,118.33 98.33,155.83 38.33,37.51 101.55,32.47 101.55,32.47 0,0 22.5,-137.23 -95.72,-279.97 l -104.16,91.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path582",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3289.57,1778.69 c 0,0 73.04,-38.13 115.83,-113.13 l -23.33,-20 c 0,0 -47.58,66.57 -107.09,104.79 l 14.59,28.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path584",
    style: {
      fill: "#45555c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3382.07,1645.56 c 0,0 -3.22,4.51 -9.04,11.85 -14.66,18.51 -45.8,55.03 -83.35,82.78 -4.8,3.55 -9.71,6.95 -14.7,10.16 l 14.59,28.34 c 0,0 73.04,-38.13 115.83,-113.13 l -23.33,-20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path586",
    style: {
      fill: "#f9b0bb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3500.82,449.941 34.26,-166.043 67.61,10 -16.25,161.661 -85.62,-5.618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path588",
    style: {
      fill: "#db8e92",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3522.24,346.148 -4.74,22.942 77.3,3.32 1.66,-16.531 c -0.12,-0.02 -0.25,-0.039 -0.37,-0.059 -8.1,-1.332 -15.71,-3.968 -22.61,-7.679 l -51.24,-1.993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path590",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3901.94,1205.56 c 0,0 34.33,-180 -83.17,-180 -117.5,0 -273.78,-38.412 -273.78,-38.412 0,0 45,-42.738 55,-587.437 l -97.5,-4.152 c 0,0 -161.96,614.791 -130,682.351 45,95.15 278,127.65 278,127.65 h 251.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path592",
    style: {
      fill: "#395eb4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3494.83,425.051 c -9.21,35.82 -25.74,100.969 -43.86,176.789 -13.22,55.301 -27.28,116.25 -40,175.719 -11.32,52.961 -21.58,104.761 -29.19,150.203 7.55,0 18.82,0 33.2,0 34.36,0 86.52,0 148.44,0.008 13.24,-66.891 29.8,-207.43 36.01,-500.079 l -104.6,-2.64 m 363.06,622.989 c 9.89,5.56 18.09,11.91 24.85,18.8 0.3,-3.32 0.62,-6.67 0.96,-9.99 -2.22,-3.11 -4.63,-6.05 -7.26,-8.79 -6.14,-0.01 -12.34,-0.01 -18.55,-0.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path594",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3481.82,424.719 132.56,3.34 -4.23,-55 -111.22,-4.758 -17.11,56.418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path596",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3498.93,368.301 -17.11,56.418 132.56,3.34 -1.14,-14.899 -0.2,-2.5 -2.89,-37.601 -15.35,-0.649 -77.3,-3.32 v 0 l -18.57,-0.789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path598",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3491.82,285.809 c -1.08,-0.11 -2.14,-0.379 -3.14,-0.797 -1.36,-0.403 -2.46,-1.41 -2.99,-2.731 -0.99,-2.211 -0.43,-3.172 0.1,-3.679 3.82,-4.192 21.59,-2.172 34.5,1.027 -9.02,3.832 -18.68,5.93 -28.47,6.18 z m 12.84,-12.36 c -8.75,-1.051 -17.99,-0.527 -21.34,2.891 -1.77,2.012 -2.07,4.93 -0.74,7.262 0.94,2.066 2.65,3.699 4.78,4.527 11.37,4.652 37.61,-6.43 38.77,-6.918 l 1.02,-1.641 -1.19,-1.539 c -6.95,-2.14 -14.08,-3.679 -21.3,-4.582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path600",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3505.06,304.469 -0.97,-0.028 c -2.97,-0.613 -3.02,-1.851 -3.09,-2.281 0.14,-4.832 12.67,-15.441 22.01,-19.558 -1.79,7.886 -5.96,15.027 -11.94,20.468 -1.77,1.192 -3.91,1.68 -6.01,1.399 z m 20.64,-26.449 -0.71,-0.008 c -8.86,2.718 -27.62,15.949 -27.06,24.058 -0.06,1.93 1.1,4.418 5.63,5.442 3.31,0.75 6.79,0.117 9.63,-1.742 9.85,-6.301 14.01,-25.059 14.21,-25.93 l -0.57,-1.602 -1.13,-0.218"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path602",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3531.96,288.762 76.86,9.226 c 2.9,0.344 5.65,-1.359 6.63,-4.117 l 21.39,-60.859 c 1.94,-5.391 -0.85,-11.313 -6.24,-13.262 l -2.13,-0.512 c -27.77,-2.847 -52.58,-4.289 -87.07,-8.476 -40.7,-4.891 -29.79,-8.532 -77.57,-14.953 -28.78,-3.84 -38,28.3 -25.97,31.382 55.11,13.758 58.9,31.348 78.08,53.981 4.23,4.398 9.94,7.109 16.02,7.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path604",
    style: {
      fill: "#f9b0bb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3303.02,405.461 63.75,-154.801 62.08,12.399 -42.7,165.632 -83.13,-23.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path606",
    style: {
      fill: "#db8e92",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3344.46,304.828 -11.76,28.563 73.65,16.949 8.29,-32.149 -70.18,-13.363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path608",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3901.94,1205.56 c 0,0 72.59,-187.75 -167.37,-180 -91.9,2.97 -489.91,-90.001 -489.91,-90.001 0,0 71.78,-37.5 161.78,-540 l -101.87,-23.118 c 0,0 -288.8,570.571 -256.85,638.119 45,95.15 518.57,195 518.57,195 h 335.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path610",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3292.07,378.891 120.83,25.828 12.5,-50 -115.83,-26.66 -17.5,50.832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path612",
    style: {
      fill: "#a1bce6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3309.57,328.059 -17.5,50.832 120.83,25.828 12.5,-50 -14.43,-3.321 -4.62,-1.058 -73.65,-16.949 v 0 l -23.13,-5.332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path614",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3315.56,255.941 c -1.08,-0.101 -2.14,-0.382 -3.14,-0.8 -1.36,-0.403 -2.46,-1.403 -2.99,-2.719 -0.99,-2.231 -0.43,-3.172 0.11,-3.684 3.81,-4.187 21.58,-2.168 34.5,1.024 -9.02,3.84 -18.68,5.929 -28.48,6.179 z m 12.85,-12.351 c -8.76,-1.051 -18,-0.539 -21.35,2.871 -1.77,2.019 -2.06,4.937 -0.74,7.277 0.94,2.071 2.66,3.703 4.78,4.532 11.37,4.652 37.61,-6.442 38.77,-6.93 l 1.02,-1.641 -1.19,-1.531 c -6.95,-2.148 -14.08,-3.68 -21.29,-4.578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path616",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3328.8,274.609 -0.97,-0.027 c -2.96,-0.621 -3.02,-1.852 -3.09,-2.293 0.14,-4.82 12.67,-15.437 22.01,-19.551 -1.79,7.883 -5.96,15.032 -11.94,20.461 -1.76,1.18 -3.9,1.692 -6.01,1.41 z m 20.64,-26.449 -0.7,-0.019 c -8.87,2.73 -27.62,15.961 -27.07,24.058 -0.06,1.93 1.1,4.43 5.64,5.43 3.31,0.769 6.78,0.141 9.62,-1.719 9.85,-6.301 14.01,-25.058 14.21,-25.941 l -0.56,-1.59 -1.14,-0.219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path618",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3355.71,258.891 76.86,9.23 c 2.9,0.34 5.64,-1.359 6.62,-4.109 l 21.4,-60.864 c 1.94,-5.386 -0.86,-11.32 -6.24,-13.257 l -2.14,-0.52 c -27.76,-2.84 -52.58,-4.281 -87.07,-8.473 -40.7,-4.898 -29.79,-8.527 -77.56,-14.957 -28.79,-3.839 -38.01,28.309 -25.97,31.379 55.11,13.77 58.89,31.36 78.07,53.981 4.23,4.41 9.94,7.117 16.03,7.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path620",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4121.58,355.82 c -61.12,10.039 -151.76,24.27 -192.14,27.239 -8.86,0.66 -19.98,1.152 -32.22,1.472 v 313.528 h -76.77 V 384.531 c -12.23,-0.32 -23.36,-0.812 -32.22,-1.472 -40.37,-2.969 -131.02,-17.2 -192.14,-27.239 -35.21,-5.789 -61.01,-36.23 -61.01,-71.922 v -15.839 h 74.46 l 10,22.281 c 0,0 139.95,24.25 187.11,27.719 26.02,1.921 78.35,1.921 104.38,0 47.15,-3.469 187.1,-27.719 187.1,-27.719 l 10,-22.281 h 74.45 v 15.839 c 0,35.692 -25.79,66.133 -61,71.922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path622",
    style: {
      fill: "#304047",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4182.58,268.059 h -74.45 l -10,22.281 c 0,0 -139.95,24.25 -187.1,27.719 -13.02,0.961 -32.6,1.441 -52.19,1.441 -19.59,0 -39.18,-0.48 -52.19,-1.441 -47.16,-3.469 -187.11,-27.719 -187.11,-27.719 l -10,-22.281 h -74.46 v 15.839 c 0,35.692 25.8,66.133 61.01,71.922 61.12,10.039 151.77,24.27 192.14,27.239 8.86,0.66 19.99,1.152 32.22,1.472 v 270.75 c 3.87,-1.429 8.05,-2.222 12.41,-2.222 h 51.95 c 4.36,0 8.55,0.793 12.41,2.23 v -242.129 -2.5 -26.129 0 c 12.24,-0.32 23.36,-0.812 32.22,-1.472 40.38,-2.969 131.02,-17.2 192.14,-27.239 35.21,-5.789 61,-36.23 61,-71.922 v -15.839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path624",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3884.81,653.059 h -51.95 c -19.69,0 -35.65,15.972 -35.65,35.66 V 953.73 h 123.26 V 688.719 c 0,-19.688 -15.97,-35.66 -35.66,-35.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path626",
    style: {
      fill: "#182124",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3920.47,880.559 h -123.26 v 47.25 c 16.87,0.011 33.78,0.011 50.63,0.011 0.76,-0.039 1.51,-0.058 2.26,-0.058 0.76,0 1.51,0.019 2.25,0.058 22.91,0.008 45.71,0.008 68.12,0.008 v -47.269"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path628",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4203.88,215.559 c 0,-28.989 -23.5,-52.5 -52.5,-52.5 -29,0 -52.5,23.511 -52.5,52.5 0,29 23.5,52.5 52.5,52.5 29,0 52.5,-23.5 52.5,-52.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path630",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3618.79,215.559 c 0,-28.989 -23.5,-52.5 -52.5,-52.5 -28.99,0 -52.5,23.511 -52.5,52.5 0,29 23.51,52.5 52.5,52.5 29,0 52.5,-23.5 52.5,-52.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path632",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4275.55,1016.14 c -73.54,18.75 -149.1,29.06 -224.87,30.97 -53.22,1.34 -205.9,0.99 -319.75,0.64 -53.21,-0.17 -97.94,-0.33 -120.05,-0.32 -84.5,0.03 -168.99,-10.38 -250.97,-31.29 -51.53,-13.14 -35.65,-87.511 10.9,-88.37 1.86,-0.032 185.08,0 384.87,0.039 240.18,0.043 504.32,0.082 506.09,0 48.69,-2.207 66.45,74.901 13.78,88.331"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path634",
    style: {
      fill: "#2e53ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3414.98,927.762 c -22.84,0 -37.83,0 -42.57,0.008 3.64,0.058 7.45,0.57 11.42,1.582 74.22,18.929 150.63,28.386 227.05,28.386 76.41,0 152.82,-9.457 227.04,-28.386 3.42,-0.872 6.74,-1.372 9.92,-1.532 -16.85,0 -33.76,0 -50.63,-0.011 -13.88,0 -27.75,0 -41.53,0 -141.28,-0.028 -274.26,-0.047 -340.7,-0.047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path636",
    style: {
      fill: "#2e53ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4263.81,927.762 c -0.67,0 -1.36,0.019 -2.04,0.047 -0.74,0.031 -46.7,0.05 -117.41,0.05 -76.87,0 -183,-0.019 -292.01,-0.039 24.77,1.282 40.54,23.571 41.47,45.68 0.92,0.48 1.82,1.02 2.68,1.609 4.17,-8.961 12.11,-13.3 20.74,-13.89 6.29,-0.43 49.45,-0.571 103.47,-0.571 100.79,0 239.41,0.493 246.99,0.5 15.89,0.043 33.2,12.301 33.17,31.571 -0.01,1.941 -0.19,3.961 -0.57,6.051 -0.08,0.492 -0.17,0.96 -0.26,1.45 5.15,-7.2 7.54,-15.868 7.54,-24.681 -0.02,-23.418 -16.93,-47.777 -43.77,-47.777 m -375.6,91.778 c -10.39,9.5 -20.77,19 -31.16,28.5 9.27,0.01 18.46,0.02 27.58,0.02 1.05,-9.52 2.24,-19.03 3.58,-28.52 m -75.07,7.73 c -62.94,12.75 -127.03,19.47 -191.21,20.17 24.27,0.03 63.54,0.17 109,0.31 19.02,0.06 39.11,0.11 59.65,0.16 7.52,-6.88 15.04,-13.76 22.56,-20.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path638",
    style: {
      fill: "#2e53ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3338.28,944.641 c -0.01,0 -0.02,0.007 -0.02,0.019 0,-0.012 0.01,-0.019 0.02,-0.019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path640",
    style: {
      fill: "#2e53ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3338.21,944.719 c -0.02,0.031 -0.04,0.062 -0.06,0.082 0.02,-0.02 0.04,-0.051 0.06,-0.082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path642",
    style: {
      fill: "#2e53ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3338.14,944.82 c -2.44,3.231 -4.47,6.782 -6.07,10.52 -2.72,6.371 -4.16,13.301 -4.17,20.16 0,17.289 9.19,34.08 30.36,40.19 -21.15,-6.1 -30.34,-22.87 -30.35,-40.139 -0.01,-10.891 3.64,-21.981 10.23,-30.731 m 20.12,70.87 c 0.15,0.04 0.29,0.09 0.44,0.13 -0.15,-0.04 -0.29,-0.08 -0.44,-0.13 m 0.45,0.13 c 0.04,0.01 0.08,0.02 0.12,0.03 -0.04,-0.01 -0.08,-0.02 -0.12,-0.03 m 0.15,0.04 c 0.04,0.01 0.07,0.02 0.12,0.03 -0.04,-0.01 -0.09,-0.02 -0.12,-0.03 m 0.15,0.04 c 0.03,0.01 0.07,0.02 0.1,0.03 -0.03,-0.01 -0.07,-0.02 -0.1,-0.03 m 0.15,0.04 c 0.03,0.01 0.07,0.02 0.1,0.03 -0.03,-0.01 -0.07,-0.02 -0.1,-0.03 m 0.15,0.04 c 0.03,0.01 0.07,0.02 0.1,0.03 -0.03,-0.01 -0.07,-0.02 -0.1,-0.03 m 0.15,0.04 c 0.03,0.01 0.06,0.02 0.09,0.03 -0.03,-0.01 -0.06,-0.02 -0.09,-0.03 m 0.15,0.04 c 0.01,0.01 0.03,0.01 0.04,0.01 -0.01,0 -0.03,0 -0.04,-0.01 m 0.3,0.08 v 0 c 8.33,2.12 16.67,4.14 25.05,6.05 -8.38,-1.91 -16.72,-3.93 -25.05,-6.05 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path644",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3383.83,929.352 c 148.44,37.847 305.66,37.847 454.09,0 56.14,-14.313 80.1,72.458 23.92,86.788 -163.94,41.81 -337.98,41.81 -501.93,0 -56.09,-14.31 -32.32,-101.128 23.92,-86.788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path646",
    style: {
      fill: "#8daee0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3371.62,927.762 c -26.85,0 -43.73,24.359 -43.71,47.789 0.01,17.719 9.68,34.899 32,40.589 81.97,20.9 166.47,31.36 250.97,31.36 67.86,0 135.71,-6.74 202.26,-20.23 18.36,-16.78 36.71,-33.571 55.07,-50.36 4.7,-4.301 9.92,-6.109 14.96,-6.109 3.74,0 7.38,0.988 10.65,2.699 -0.96,-22.781 -17.66,-45.738 -43.72,-45.738 -0.75,0 -1.5,0.019 -2.26,0.058 -3.18,0.16 -6.5,0.66 -9.92,1.532 -74.22,18.929 -150.63,28.386 -227.04,28.386 -76.42,0 -152.83,-9.457 -227.05,-28.386 -3.97,-1.012 -7.78,-1.524 -11.42,-1.582 -0.26,-0.008 -0.53,-0.008 -0.79,-0.008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path648",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4039.23,1660.14 c -9.29,0.18 -18.63,-3.98 -24.85,-14.32 -119.05,-197.97 -161.34,-435.95 -120.27,-663 2.58,-14.23 12.32,-20.859 23.13,-21.601 18.02,-1.231 338.82,-0.09 350.46,-0.071 17.49,0.043 36.72,14.903 32.6,37.622 -38.16,210.99 3.87,433.24 114.22,616.77 13.72,22.81 -6.51,44.2 -26.95,44.6 -4.05,0.08 -66.55,0.02 -137.61,-0.05 -92.36,-0.09 -199.17,-0.17 -210.73,0.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path650",
    style: {
      fill: "#395eb4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4020.71,960.648 c -54.02,0 -97.18,0.141 -103.47,0.571 -8.63,0.59 -16.57,4.929 -20.74,13.89 v 0 c 4.5,-9.668 13.4,-13.961 22.8,-13.961 15.91,0 33.26,12.27 33.23,31.563 0,1.949 -0.18,3.969 -0.56,6.059 -9.24,51.1 -13.78,102.86 -13.79,154.57 -0.01,161.8 44.38,323.12 128.01,462.2 3.14,5.21 4.5,10.35 4.49,15.19 -0.04,16.5 -16.06,29.42 -32.02,29.42 -2.85,0 -5.69,-0.41 -8.44,-1.29 2.76,0.88 5.6,1.29 8.45,1.29 0.19,0 0.38,0 0.56,-0.01 5.51,-0.1 32.63,-0.14 69.5,-0.14 40.54,0 92.87,0.04 141.23,0.09 48.25,0.04 92.56,0.09 117.3,0.09 11.69,0 19.01,-0.01 20.31,-0.04 15.77,-0.3 31.41,-13.11 31.44,-29.42 0.01,-4.83 -1.35,-9.97 -4.49,-15.18 -83.63,-139.08 -128.02,-300.4 -128,-462.2 0,-51.71 4.54,-103.47 13.78,-154.57 0.38,-2.09 0.56,-4.11 0.57,-6.051 0.03,-19.27 -17.28,-31.528 -33.17,-31.571 -7.58,-0.007 -146.2,-0.5 -246.99,-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path652",
    style: {
      fill: "#395eb4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4030.12,1658.83 c 0.03,0.01 0.06,0.02 0.09,0.03 -0.03,-0.01 -0.06,-0.02 -0.09,-0.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path654",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3951.97,998.77 c -38.17,210.99 3.86,433.24 114.22,616.77 19.95,33.17 -31.91,63.37 -51.81,30.28 -119.05,-197.97 -161.34,-435.95 -120.27,-663 6.87,-37.941 64.71,-21.871 57.86,15.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path656",
    style: {
      fill: "#8daee0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3919.3,961.148 c -9.4,0 -18.3,4.293 -22.8,13.961 6.28,4.332 10.64,11.391 10.62,18.75 -0.01,5.082 -2.1,10.301 -7.09,14.871 -3.94,3.6 -7.88,7.21 -11.82,10.81 -2.22,15.73 -4.04,31.51 -5.47,47.3 -2.61,28.92 -3.91,57.89 -3.9,86.85 0.02,172.22 46.14,343.46 135.54,492.13 6.09,10.13 15.17,14.33 24.28,14.33 15.96,0 31.98,-12.92 32.02,-29.42 0.01,-4.84 -1.35,-9.98 -4.49,-15.19 -83.63,-139.08 -128.02,-300.4 -128.01,-462.2 0.01,-51.71 4.55,-103.47 13.79,-154.57 0.38,-2.09 0.56,-4.11 0.56,-6.059 0.03,-19.293 -17.32,-31.563 -33.23,-31.563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path658",
    style: {
      fill: "#1d2a30",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3559.07,1259.66 c 103.05,-94.25 206.09,-188.5 309.14,-282.75 21.33,-19.519 53.24,12.219 31.82,31.82 -103.05,94.25 -206.09,188.49 -309.13,282.74 -21.34,19.51 -53.25,-12.22 -31.83,-31.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path660",
    style: {
      fill: "#8e989b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3883.17,970.801 c -5.04,0 -10.26,1.808 -14.96,6.109 -83.34,76.22 -166.66,152.43 -249.99,228.65 h 66.6 c 71.74,-65.61 143.47,-131.22 215.21,-196.83 4.99,-4.57 7.08,-9.789 7.09,-14.871 0.02,-7.359 -4.34,-14.418 -10.62,-18.75 v 0 0 c -3.9,-2.679 -8.54,-4.32 -13.33,-4.308"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path662",
    style: {
      fill: "#182124",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3684.82,1205.56 v 0 c -14.58,13.34 -29.16,26.67 -43.73,40 v 0 c 14.58,-13.33 29.15,-26.66 43.73,-40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path664",
    style: {
      fill: "#182124",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3618.22,1205.56 v 0 c -14.58,13.34 -29.16,26.67 -43.74,40 0.01,0 -0.01,0 0,0 14.57,-13.32 29.16,-26.67 43.74,-40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path666",
    style: {
      fill: "#6e767b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3684.82,1205.56 h -66.6 c -14.58,13.33 -29.17,26.68 -43.74,40 22.29,0 44.34,0 66.61,0 14.57,-13.33 29.15,-26.66 43.73,-40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path668",
    style: {
      fill: "#4870c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3397.91,1245.56 c 158.05,0 266.1,0 424.16,0 38.6,0 38.67,60 0,60 -158.06,0 -266.11,0 -424.16,0 -38.61,0 -38.68,-60 0,-60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path670",
    style: {
      fill: "#799bd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3822.07,1245.56 c -66.73,0 -124.56,0 -180.98,0 -22.27,0 -44.32,0 -66.61,0 -39.54,0 -79.85,0 -123.51,0 -13.02,0 -26.32,0 -40,0 -4.32,0 -8.67,0 -13.06,0 -19.34,0 -28.99,15 -28.98,30 0,15 9.67,30 28.98,30 158.05,0 266.1,0 424.16,0 19.33,0 28.98,-15 28.98,-30 -0.01,-15 -9.68,-30 -28.98,-30"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIllustration);
export default __webpack_public_path__ + "static/media/admin_illustration.21707824be6dc009674a73f22f5ceaa4.svg";
export { ForwardRef as ReactComponent };